'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "domenica",
      "luned\u00ec",
      "marted\u00ec",
      "mercoled\u00ec",
      "gioved\u00ec",
      "venerd\u00ec",
      "sabato"
    ],
    "ERANAMES": [
      "avanti Cristo",
      "dopo Cristo"
    ],
    "ERAS": [
      "a.C.",
      "d.C."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre"
    ],
    "SHORTDAY": [
      "dom",
      "lun",
      "mar",
      "mer",
      "gio",
      "ven",
      "sab"
    ],
    "SHORTMONTH": [
      "gen",
      "feb",
      "mar",
      "apr",
      "mag",
      "giu",
      "lug",
      "ago",
      "set",
      "ott",
      "nov",
      "dic"
    ],
    "STANDALONEMONTH": [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "dd MMM y HH:mm:ss",
    "mediumDate": "dd MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/yy HH:mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "it-it",
  "localeID": "it_IT",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

(function() {
    'use strict';

    angular
        .module(
            'biolaser',
            [
                'ngAnimate',
                'ngCookies',
                'ngTouch',
                'ngSanitize',
                'ngMessages',
                'ngAria',
                'ngResource',
                'restangular',
                'ui.router',
                'ngMaterial',
                'ngMaterialDatePicker',
                'ui.bootstrap',
                'toastr',
                'uiGmapgoogle-maps',
                'bootstrapLightbox',
                'ngDialog',
                'satellizer',
                'vcRecaptcha',
                'ngRateIt',
                'mgo-angular-wizard',
                'phonefriends',
                'birthday',
                'booking',
            ]
        )
    ;
})();


(function() {
    'use strict';

    angular
        .module('biolaser')
        .directive('radioButtons', radioButtons);

    function radioButtons($filter) {
        var directive = {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=',
                model: '=ngModel'
            },
            templateUrl: 'app/components/radio-buttons/radio-buttons.html',
        //             template:   '<div class="btn-group">' +
        // '<a href="javascript:void(0)" class="btn" ng-class="{true:\'active\', false:\'\'}[selectedValue==option.value]" ng-repeat="option in options" ng-click="select(scope, option.value)" value="{{option.value}}">{{option.label}}</a>' +
        //             '</div>',
            replace: true,
            link: linker
        };

        return directive;


        function linker(scope) {
            scope.select = select;
            scope.scope = scope;
            scope.selectedValue = scope.model;
            
            // scope.$watch("model", function() {
            //    $log.info("Changed"); 
            // });
 
        }

        function select(scope, val) {
            scope.selectedValue = val;
            scope.model = val;
            scope.options = $filter('setActiveRadioButtonFilter')(scope.model,scope.options);
        }


    }

})();


(function () {
    'use strict';

    angular
            .module('phonefriends', [])
            .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
                .state('phonefriends-completed', {
                    url: '/pf/completed',
                    templateUrl: 'app/phonefriends/completed.html',
                    controller: 'PhoneFriendsCompletedController',
                    controllerAs: 'completed'
                })
                .state('phonefriends', {
                    url: '/pf?cph&crdid&customer&token&c_role&c_sid',
                    templateUrl: 'app/phonefriends/phonefriends.html',
                    controller: 'PhoneFriendsController',
                    controllerAs: 'phonefriends',
                    resolve: {
                        userPhone: function ($stateParams) {
                            return $stateParams.cph ? $stateParams.cph : ($stateParams.customer ? $stateParams.customer : null);
                        },
                        cardId: function ($stateParams) {
                            return $stateParams.crdid ? $stateParams.crdid : null;
                        },
                        token: function ($stateParams) {
                            return $stateParams.token ? $stateParams.token : null;
                        },
                        userRole: function($stateParams){
                          if($stateParams.c_role){
                            return $stateParams.c_role;
                          } else {
                            return null;
                          }
                        },
                        userSid: function($stateParams){
                          if($stateParams.c_sid != null && $stateParams.c_sid!= 'null'){
                            return parseInt($stateParams.c_sid);
                          } else {
                            return null;
                          }
                        }
                    },
                })
                ;
    }

})();


(function() {
    'use strict';

    angular
        .module('phonefriends')

        .factory('CustomerService', function(Restangular, $filter) {

            var service = {};

            service.all = function(options){
                return Restangular.all('customers/search_by_phone').getList(options);
            };

            return service;
        })
        .factory('ProspectService', function(Restangular, $filter) {

            var service = {};

            service.save = function(data, isUser){
            	if (isUser) {
            		return Restangular.all('leads_a').post(data);
            	} else {
            		return Restangular.all('leads').post(data);
            	}
            };

            return service;
        })
})();

(function() {
    'use strict';

    angular
        .module('phonefriends')
})();

 
(function () {
    'use strict';
    angular
            .module('phonefriends')
            .controller('PhoneFriendsController', PhoneFriendsController)
            .controller('PhoneFriendsCompletedController', PhoneFriendsCompletedController);
    /** @ngInject */
    function PhoneFriendsController(
            env,
            $log,
            $state,
            ngDialog,
            $scope,
            $rootScope,
            CustomerService,
            ProspectService,
            WizardHandler,
            UserService,
            TokenService,
            userPhone,
            cardId,
            token,
            userRole,
            userSid
            ) {
        var vm = this;
        vm.env = env;
        vm.version = "2.6";
        /**
         * TODO da gestire
         * Utente loggato
         */
        vm.user = null;
        vm.isUser = true;
        vm.token = token;
        //$log.info(token);
        //$log.info(UserService);
        //DEFAULT
        vm.step = 0;
        vm.prospect = {
            firstname: null,
            lastname: null,
            phone: null
        };
        vm.savedProspectFlag = false;
        vm.newCustomer = function (phone) {
            return {
                firstname: null,
                lastname: null,
                phone: phone,
                birthdate: null,
                email: null,
                gender: null,
                referral_code: null,
                overwritten_by_lead: 0,
                change_state_counter: 0,
                credit: 0,
                user_times: 0,
                app_times: 0
            };
        }
        vm.customer = vm.newCustomer(null);
        vm.getErrorMsg = function (response) {
            if (!vm.isUser)
                return null;
            var msg = null;
            if (response.data != null && response.data.message != null) {
                msg = response.data != null && response.data.message != null ? "\n\nERRORE: " + response.data.message : "";
                msg += response.config != null && response.config.url != null ? "\nURL: " + response.config.url : "";
                if (vm.user.id == 20 || vm.user.type == 'admin') {
                    if (response.data != null && response.data.debug != null) {
                        msg += "\n\nCLASS: " + response.data.debug.class;
                        msg += "\nTRACE:";
                        for (var i = 0; i < response.data.debug.trace.length && i < 5; i++) {
                            msg += "\n" + response.data.debug.trace[i];
                        }
                    }
                }
            }
            return msg;
        };
        //---------- customerdata -------------------------------------//

        vm.customerChecking = false;
        vm.customerLoaded = null;
        vm.user_times = 2;
        vm.checkCustomer = function () {
            if (vm.customer.phone == null || vm.customer.phone.trim() == '')
                return;
            vm.customerChecking = true;
            vm.customerLoaded = null;
            /**
             * Devo eseguire solo se il cell è valido
             */
            CustomerService.all({'search': vm.customer.phone, 'searchFields': 'phone:=', 'with': 'lastStore'}, vm.env.API).then(
                    function (data) {
                        vm.customerChecking = false;
                        if (data.length >= 1) {
                            vm.customer = data[0];
                            vm.customerLoaded = true;
                            ga('set', 'page', '/pf/checkcustomer');
                            ga('send', 'pageview');
                        } else {
                        	ga('set', 'page', '/pf/checkcustomer/notfound');
                        	ga('send', 'pageview');
                            vm.customerLoaded = false;
                        }
                    },
                    function (data) {
                        var msg = vm.getErrorMsg(data);
                        alert("C'è stato un problema nel caricamento della cliente." + (msg != null ? " " + msg : ""));
                        vm.customerChecking = false;
                        ga('set', 'page', '/pf/checkcustomer/error');
                    	ga('send', 'pageview');
                    }
            );
        };
        
        if (userPhone) {
            vm.customer.phone = userPhone;
            vm.checkCustomer();
        }
        if (cardId) {
            vm.cardId = cardId;
        }
        $scope.saving = false;
        $scope.saveProspect = function (step, goBooking) {
            if (vm.customerLoaded) {
            	$scope.saving = true;
            	var lead = {
                        'src_cid': vm.customer.id,
                        'telefono': vm.prospect.phone,
                        'user_first_name': vm.prospect.firstname,
                        'user_last_name': vm.prospect.lastname,
                        'campagna': 'PhoneFriend',
                        'step': step,
                        'card_id': vm.cardId,
                        'c_sid': vm.user.store_id,
                        'c_role': vm.user.type
                    };
            	if (vm.isUser && (vm.user.type == 'callcenter' || vm.user.type == 'admin')) {
            		lead.operator_assign = 'y';
            		lead.operator_email = vm.user.email;
            	}
                ProspectService.save(lead, vm.isUser).then(
                        function (data) {
                        	vm.step = step;
                        	$log.info(data);
                        	$scope.saving = false;
                            if (data.id) {
                            	if (goBooking) {
                            		//alert ("devo andare al booking");
                            		window.location = "/operator?lead="+data.id+"&customer="+data.telefono+"&token="+vm.token;
                            		return;
                            	}
                            	if (step < 5) {
                            		vm.savedProspectFlag = true;
                                    vm.prospect.phone = "";
                                    vm.prospect.firstname = "";
                                    vm.prospect.lastname = "";
                                    WizardHandler.wizard('addProspects').goTo(step);
                                    ga('set', 'page', '/pf/step'+step);
                                    ga('send', 'pageview');
                                } else if (step == 5) {
                                    $rootScope.customer = vm.customer;
                                    if (vm.isUser) {
                                    	vm.back();
                                    } else {
                                    	$state.go('phonefriends-completed');
                                    }
                                }
                            } else {
                                var msg = vm.getErrorMsg(data);
                                alert("C'è stato un problema nel salvataggio." + (msg != null ? " " + msg : ""));
                                vm.savedProspectFlag = false;
								ga('set', 'page', '/pf/step'+step+'/error');
                                ga('send', 'pageview');
                            }
                        },
                        function (data) {
                        	$scope.saving = false;
                            var msg = vm.getErrorMsg(data);
                            alert("C'è stato un problema nel salvataggio." + (msg != null ? " " + msg : ""));
                            vm.savedProspectFlag = false;
							ga('set', 'page', '/pf/step'+step+'/error');
                            ga('send', 'pageview');
                        }
                );
            } else {
                vm.savedProspectFlag = false;
            }
        };
        
     // Check for User logged-in
        vm.redirectLogout = function() {
            return window.location.replace( env.booking + '/notauthorized' );
        };
        
        vm.removeLocalStorage = function() {
            localStorage.removeItem( 'Biolaser_token' );
            localStorage.removeItem( 'user' );
        };
        if (!token) {
        	vm.removeLocalStorage();
        }
        vm.doLogout = function() {
            TokenService
                .delete()
                .finally( function() {
                    vm.removeLocalStorage();
                    if (vm.isUser) {
                    	return  vm.redirectLogout();
                    }
                } )
            ;
        };
	    if ( token ) {
            localStorage.setItem( 'Biolaser_token', token );
            UserService
                .logIn()
                .then(
                    function( response ) {
                    	//$log.info(response);
                        if( response.data.user ) {
                            localStorage.setItem( 'user', angular.toJson( response.data.user ) );
                            /* Operatore connesso */
                            var user = angular.fromJson( localStorage.getItem( 'user' ) );
                            if( user ) {
                                //vm.operator = user;
                            	vm.user = user;
                            	vm.isUser = true;
                            	angular.forEach(vm.user.roles, function (r) {
                            	  if (r.active && userRole == r.role && r.store_id == userSid) {
                            	    vm.user.type = userRole;
                            	    vm.user.color = r.color;
                            	    vm.user.store_id = userSid;
                            	  }
                            	});
                            	if (userRole == 'operator' || userRole == 'storemngr') {
                            	  vm.isStoreUser = true;
                            	} else {
                            	  vm.isStoreUser = false;
                            	}
                            	vm.operatorId = user.id;
                                vm.user_type = user.type;
                                vm.isCallCenter = ( vm.user_type === 'callcenter' ||  vm.user_type === 'admin') ? true : false;
                            } else {
                                vm.doLogout();
                            }
                        }
                    },
                    vm.doLogout
                );
        } else {
            vm.isUser = false;
        };
        
        vm.back = function () {
          if (vm.user.type == 'callcenter') {
            window.location = env.admin + "/leads";
          } else {
            window.location = env.admin + "/appointments";
          }
        };
        
    };
    
    function PhoneFriendsCompletedController($rootScope, $log) {
        var vm = this;
        ga('set', 'page', '/pf/completed');
        ga('send', 'pageview');
        $log.info("PhoneFriend Completed");
    }
    ;
})();

(function() {
  'use strict';

  angular
    .module('booking',[])
    .config(routerConfig);

  /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('booking-completed', {
                url: '/completed',
                templateUrl: 'app/booking/completed.html',
                controller: 'BookingCompletedController',
                controllerAs: 'completed'
            })
            .state('booking-notauthorized', {
                url: '/notauthorized',
                templateUrl: 'app/booking/notauthorized.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-promo-expired', {
                url: '/promoexpired',
                templateUrl: 'app/booking/promoexpired.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-promo-already', {
                url: '/promoalready',
                templateUrl: 'app/booking/promoalready.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-operator', {
                url: '/operator?kpiCheck&debug&tenant&token&c_role&c_sid&store&customer&firstname&lead&tag&campagna&caid&callcenter&appointment&treatment&appointmentDate&wkFlow&wkStateTo&wkStateFrom&wkEntityId&referral',
                templateUrl: 'app/booking/booking.html',
                controller: 'BookingController',
                controllerAs: 'booking',
                resolve: {
                    tenant: function( $stateParams ) {
                        if( $stateParams.tenant ) {
                            return $stateParams.tenant;
                        } else {
                            return null;
                        };
                    },
                    debug: function( $stateParams ) {
                        if( $stateParams.debug ) {
                            return $stateParams.debug;
                        } else {
                            return null;
                        };
                    },
                    kpiCheck: function( $stateParams ) {
                        if( $stateParams.kpiCheck ) {
                            return $stateParams.kpiCheck;
                        } else {
                            return null;
                        };
                    },
                    token: function( $stateParams ) {
                        if( $stateParams.token ) {
                            return $stateParams.token;
                        } else {
                            return null;
                        };
                    },
                    isUser: function(){
                        return true;
                    },
                    userRole: function($stateParams){
                      if($stateParams.c_role){
                        return $stateParams.c_role;
                      } else {
                        return null;
                      }
                    },
                    userSid: function($stateParams){
                      if($stateParams.c_sid != null && $stateParams.c_sid!= 'null'){
                        return parseInt($stateParams.c_sid);
                      } else {
                        return null;
                      }
                    },
                    storeId: function($stateParams){
                        if($stateParams.store){
                            return parseInt($stateParams.store);
                        }else{
                            return null;
                        }
                    },
                    customerId: function($stateParams){
                        if($stateParams.customer){
                            return $stateParams.customer;
                        }else{
                            return null;
                        }
                    },
                    firstname: function($stateParams){
                        if($stateParams.firstname){
                            return $stateParams.firstname;
                        }else{
                            return null;
                        }
                    },
                    leadId: function($stateParams){
                      if($stateParams.lead) {
                          return $stateParams.lead;
                      } else {
                          return null;
                      }
                    },
                    tag: function($stateParams){
                        if($stateParams.tag) {
                            return $stateParams.tag;
                        } else {
                            return null;
                        }
                    },
                    campagna: function($stateParams){
                        if($stateParams.campagna) {
                            return $stateParams.campagna;
                        } else {
                            return null;
                        }
                    },
                    cusActId: function($stateParams){
                      if($stateParams.caid) {
                          return $stateParams.caid;
                      } else {
                          return null;
                      }
                    },
                    treatmentId: function($stateParams){
                        if($stateParams.treatment) {
                            return $stateParams.treatment;
                        } else {
                            return null;
                        }
                    },
                    appointmentId: function($stateParams){
                        if($stateParams.appointment) {
                            return $stateParams.appointment;
                        } else {
                            return null;
                        }
                    },
                    appointmentDate: function($stateParams){
                        if($stateParams.appointmentDate){
                            return moment($stateParams.appointmentDate).format("DD/MM/YYYY HH:mm");
                        }else{
                            return null;
                        }
                    },
                    callCenter: function($stateParams){
                        if($stateParams.callcenter) {
                            return $stateParams.callcenter!='false' && ($stateParams.callcenter=='true' || parseInt($stateParams.callcenter)>0);
                        } else {
                            return null;
                        }
                    },
                    birthtime: function() {
                        return null;
                    },
                    landing: function(){
                        return null;
                    },
                    source: function(){
                        return null;
                    },
                    couponCode: function(){
                        return null;
                    },
                    appCustomerId: function(){
                        return null;
                    },
                    utmSource: function(){
                        return null;
                    },
                    utmMedium: function(){
                        return null;
                    },
                    utmChannel: function(){
                        return null;
                    },
                    utmRegion: function(){
                        return null;
                    },
                    utmGender: function(){
                        return null;
                    },
                    utmTreatment: function(){
                    },
                    utmCreative: function(){
                        return null;
                    },
                    utmCampaign: function(){
                        return null;
                    },
                    utmAid: function(){
                        return null;
                    },
                    utmPricing: function(){
                        return null;
                    },
                    wkFlow: function($stateParams){
                        if($stateParams.wkFlow) {
                            return $stateParams.wkFlow;
                        } else {
                            return null;
                        }
                    },
                    wkStateFrom: function($stateParams){
                        if($stateParams.wkStateFrom) {
                            return $stateParams.wkStateFrom;
                        } else {
                            return null;
                        }
                    },
                    wkStateTo: function($stateParams){
                        if($stateParams.wkStateTo) {
                            return $stateParams.wkStateTo;
                        } else {
                            return null;
                        }
                    },
                    wkEntityId: function($stateParams){
                        if($stateParams.wkEntityId) {
                            return $stateParams.wkEntityId;
                        } else {
                            return null;
                        }
                    },
                    referral: function($stateParams){
                        if($stateParams.referral) {
                            return $stateParams.referral;
                        } else {
                            return null;
                        }
                    }
                }
            })
            .state('booking', {
                url: '/:code?bt&customer&firstname&tag&store&lead&treatment&source&coupon_code&app_customer_id&appointment&appointmentDate&utm_source&utm_medium&utm_campaign&utm_gender&utm_region&utm_treatment&utm_aid&utm_creative&utm_channel&utm_pricing&wkFlow&wkStateTo&wkStateFrom&wkEntityId&referral',
                templateUrl: 'app/booking/booking.html',
                controller: 'BookingController',
                controllerAs: 'booking',
                resolve: {
                    tenant: function(){
                        return null;
                    },
                    debug: function(){
                        return null;
                    },
                    kpiCheck: function(){
                        return null;
                    },
                    token: function(){
                        return null;
                    },
                    isUser: function(){
                        return false;
                    },
                    userRole: function(){
                      return 'guest';
                    },
                    userSid: function(){
                      return null;
                    },
                    storeId: function($stateParams){
                        if($stateParams.store){
                            return parseInt($stateParams.store);
                        }else{
                            return null;
                        }
                    },
                    customerId: function($stateParams){
                        if($stateParams.customer){
                            return $stateParams.customer;
                        }else{
                            return null;
                        }
                    },
                    firstname: function($stateParams){
                        if($stateParams.firstname){
                            return $stateParams.firstname;
                        }else{
                            return null;
                        }
                    },
                    leadId: function($stateParams){
                      if($stateParams.lead){
                          return $stateParams.lead;
                      }else{
                          return null;
                      }
                    },
                    tag: function($stateParams){
                        if($stateParams.tag){
                            return $stateParams.tag;
                        }else{
                            return null;
                        }
                    },
                    operatorId: function(){
                        return null;
                    },
                    cusActId: function(){
                      return null;
                    },
                    treatmentId: function($stateParams){
                        if($stateParams.treatment){
                            return $stateParams.treatment;
                        }else{
                            return null;
                        }
                    },
                    appointmentId: function($stateParams){
                        if($stateParams.appointment) {
                            return $stateParams.appointment;
                        } else {
                            return null;
                        }
                    },
                    appointmentDate: function($stateParams){
                        if($stateParams.appointmentDate){
                            return moment($stateParams.appointmentDate).format("DD/MM/YYYY HH:mm");
                        }else{
                            return null;
                        }
                    },
                    campagna: function(){
                        return null;
                    },
                    callCenter: function(){
                        return null;
                    },
                    birthtime: function($stateParams) {
                        if ($stateParams.bt) {
                            return $stateParams.bt;
                        } else {
                            return null;
                        }
                    },
                    landing: function($stateParams, LandingService){
                        if($stateParams.code){
                            return LandingService
                                .all({with:'stores;stores.operators;landing_treatments',search:$stateParams.code,searchFields:'code:='})
                                .then(function(data){
                                    return data[0];
                                })
                            ;
                        }else{
                            return null;
                        }
                    },
                    source: function($stateParams){
                        if($stateParams.source) {
                            return $stateParams.source;
                        } else {
                            return null;
                        }
                    },
                    couponCode: function($stateParams){
                        if($stateParams.coupon_code) {
                            return $stateParams.coupon_code;
                        } else {
                            return null;
                        }
                    },
                    appCustomerId: function($stateParams){
                        if($stateParams.app_customer_id) {
                            return $stateParams.app_customer_id;
                        } else {
                            return null;
                        }
                    },
                    utmSource: function($stateParams){
                        if($stateParams.utm_source) {
                            return $stateParams.utm_source;
                        } else {
                            return null;
                        }
                    },
                    utmMedium: function($stateParams){
                        if($stateParams.utm_medium) {
                            return $stateParams.utm_medium;
                        } else {
                            return null;
                        }
                    },
                    utmChannel: function($stateParams){
                        if($stateParams.utm_channel) {
                            return $stateParams.utm_channel;
                        } else {
                            return null;
                        }
                    },
                    utmRegion: function($stateParams){
                        if($stateParams.utm_region) {
                            return $stateParams.utm_region;
                        } else {
                            return null;
                        }
                    },
                    utmGender: function($stateParams){
                        if($stateParams.utm_gender) {
                            return $stateParams.utm_gender;
                        } else {
                            return null;
                        }
                    },
                    utmTreatment: function($stateParams){
                        if($stateParams.utm_treatment) {
                            return $stateParams.utm_treatment;
                        } else {
                            return null;
                        }
                    },
                    utmCreative: function($stateParams){
                        if($stateParams.utm_creative) {
                            return $stateParams.utm_creative;
                        } else {
                            return null;
                        }
                    },
                    utmCampaign: function($stateParams){
                        if($stateParams.utm_campaign) {
                            return $stateParams.utm_campaign;
                        } else {
                            return null;
                        }
                    },
                    utmAid: function($stateParams){
                        if($stateParams.utm_aid) {
                            return $stateParams.utm_aid;
                        } else {
                            return null;
                        }
                    },
                    utmPricing: function($stateParams){
                        if($stateParams.utm_pricing) {
                            return $stateParams.utm_pricing;
                        } else {
                            return null;
                        }
                    },
                    wkFlow: function($stateParams){
                        if($stateParams.wkFlow) {
                            return $stateParams.wkFlow;
                        } else {
                            return null;
                        }
                    },
                    wkStateFrom: function($stateParams){
                        if($stateParams.wkStateFrom) {
                            return $stateParams.wkStateFrom;
                        } else {
                            return null;
                        }
                    },
                    wkStateTo: function($stateParams){
                        if($stateParams.wkStateTo) {
                            return $stateParams.wkStateTo;
                        } else {
                            return null;
                        }
                    },
                    wkEntityId: function($stateParams){
                        if($stateParams.wkEntityId) {
                            return $stateParams.wkEntityId;
                        } else {
                            return null;
                        }
                    },
                    referral: function($stateParams){
                        if($stateParams.referral) {
                            return $stateParams.referral;
                        } else {
                            return null;
                        }
                    }
                }
            })
        ;
    }

})();


(function() {
    'use strict';

    angular
        .module('booking')

        .service(
            'SubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )
        .service(
            'MyAvailabilityService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    availabilitiesCount : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/appointments-available-count';
                        return $http.get( apiURI, { params: options } );
                    },
                  availabilities: function( options, api ) {
                      if( ! options ) {
                          options = {};
                      }
                      var apiURI = api + '/appointments-available';
                      return $http.get( apiURI, { params: options } );
                  },
                };
            }
        )
        .service(
            'CustomerSubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/customer_subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )

        .filter( 'subscriptionIdtoName', function() {
            return function ( selected, array, quantity_remaining ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0 ) {
                    var value = "";
                    angular.forEach( array, function ( elemArray ) {
                        if ( angular.equals( elemArray.id, selected ) ) {
                            value = elemArray.name + ' (' + quantity_remaining + ' rimaste)';
                        }
                    });
                    return value;
                }
                return selected;
            };
        })

        .factory('TreatmentService', function(Restangular) {

            var service = {};

            service.categories = function(api){
                Restangular.setBaseUrl(api);
                return Restangular.all('treatments-categories').getList({
                  with: 'treatments'
                });
            };

            return service;
        })

        .factory('StoreService', function(Restangular) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('stores').getList(options);
            };

            return service;
        })

        .factory('AppointmentService', function(Restangular) {

            var service = {};

            service.availabilities = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments-available').getList(options);
            };

            service.availabilitiesCount = function(options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments-available-count').getList(options);
            };

            service.save = function(data,api) {
                Restangular.setBaseUrl(api);
                delete data.customer;
                delete data.role;
                delete data.user;
                //console.log(data);
                return Restangular.all('appointments').post(data);
            };
            service.get = function(id, options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.one('appointments', id).get(options);
            };

            service.getAnon = function(id, options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.one('appointments_anon', id).get(options);
            };

            service.all = function(options,api) {
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments').getList(options);
            };

            return service;
        })

        .factory( 'TokenService', function( $http, env ) {
            var service = {};

            service.delete = function() {
                var apiURI = env.API + '/invalidate'
                    , data = {
                        token: localStorage.getItem( 'Biolaser_token' ),
                    }
                ;
                return $http.post( apiURI, data );
            };

            return service;
        })

        .factory('UserService', function(Restangular, $http, env) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('users').getList(options);
            };

            /**
             * Carica l'utente dal token
             */
            service.logIn = function(token) {
                var apiURI = env.API + '/auth/user';
                return $http.get( apiURI );
            };

            return service;
        })

        .factory('CustomerService', function(Restangular, $filter) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('customers/search_by_phone').getList(options);
            };

            service.save = function(data, api){
                Restangular.setBaseUrl(api);
                var new_data = data;
                new_data.birthdate = new_data.birthdate ? $filter('date')( new Date( new_data.birthdate ), 'yyyy-MM-dd' ) : null;

                return Restangular.all('customers').post(new_data);
            };

            return service;
        })

        .factory('LandingService', function(Restangular) {

            var service = Restangular.all('landings');

            service.all = function(options){
                return service.getList(options);
            };

            return service;
        });

})();

(function() {
    'use strict';

    angular
        .module('booking')


        // restituisce l'array dei radio con uno selezionato
        .filter( 'setActiveRadioButtonFilter', function() {
            return function(value, values) {
                angular.forEach(values, function(this_value) {
                    if(this_value.value == value){
                        this_value.active = true;
                    }
                    else {
                        this_value.active = false;
                    }
                });
                return values;
            }
        })


        // restituisce l'array dei sessi in base al fatto che ci sia almeno un trattamento per ogni sesso
        .filter( 'setGendersFilter', function() {
            return function( treatments, genders ) {
                var gendersList = [];

                angular.forEach(genders, function(one_gender) {
                    angular.forEach(treatments, function(categories) {
                        angular.forEach(categories.treatments.data, function(one_treatment) {
                            if(one_gender.value == one_treatment.gender || one_treatment.gender == 'U'){
                                gendersList.push(one_gender);
                            }
                        });
                    });
                });

                return _.uniq(gendersList);
            }
        })


        // restituisce true se il tab ha almeno un elemento
        .filter( 'showTabFilter', function() {
            return function( tab, gender, landing ) {
                if(landing){
                    return _.filter(tab.treatments.data, function(o) {
                        var treatmentInLanding = landing.treatment_id == o.id;
                        if (!treatmentInLanding && landing.landing_treatments
                            && landing.landing_treatments.data) {
                            landing.landing_treatments.data.forEach(function (t) {
                                if (t.treatment_id == o.id) {
                                    treatmentInLanding = true;
                                }
                            });
                        }
                        return (o.gender==gender || o.gender=='U') && treatmentInLanding; }).length;
                }else{
                    return _.filter(tab.treatments.data, function(o) { return o.gender==gender || o.gender=='U'; }).length;
                }
            }
        })

        .filter( 'searchTreatment', function($filter,$log) {
            return function( treatments, currentCategory, selectedTreatment, search ) {
                var treatmentsList = $filter('filter')(treatments, search);
                //$log.info (selectedTreatment);
                if (selectedTreatment==null || selectedTreatment.treatment_category_id != currentCategory ) {
                    //nulla
                } else if (selectedTreatment.treatment_category_id == currentCategory) {
                    /*var found = false;
                    angular.forEach(treatmentsList, function(t) {
                        if(t.id == selectedTreatment.id) {
                            found = true;
                        }
                    });
                    if (!found) {
                        treatmentsList.push(selectedTreatment);
                    }*/
                }
                return treatmentsList;
            }
        })


        // restituisce il trattamento dall id
        .filter( 'getTreatmentFilter', function() {
            return function( categories, id , without_activation) {
                var treatment = {id: id, name: "Trattamento eliminato [tid="+id+"]"};
                angular.forEach(categories, function(one_category) {
                    angular.forEach(one_category.treatments.data, function(one_treatment) {
                        if(one_treatment.id==id){
                            treatment=one_treatment;
                            if (!without_activation) {
                                one_category.active = true;
                            }
                        } else {
                            if (!without_activation) {
                                one_category.active = false;
                            }
                        }
                    });
                });
                return treatment;

            }
        })

        // restituisce l'array di Trattamenti filtrati per sesso
        .filter( 'getGenderTreatmentsFilter', function() {
            return function( treatments, gender, landing ) {
                if(landing){
                    return _.orderBy(_.filter(treatments,  function(o) {
                        var treatmentInLanding = landing.treatment_id == o.id;
                        if (!treatmentInLanding && landing.landing_treatments
                            && landing.landing_treatments.data) {
                            landing.landing_treatments.data.forEach(function (t) {
                                if (t.treatment_id == o.id) {
                                    treatmentInLanding = true;
                                }
                            });
                        }
                        return (o.gender==gender || o.gender=='U') && treatmentInLanding;
                    }), ['order']);
                }else{
                    return _.orderBy(_.filter(treatments,  function(o) { return o.gender==gender || o.gender=='U'; }), ['order']);
                }
            }
        })



        // restituisce l'oggetto trattamento dall'id
        /*.filter( 'getTreatmentFilter', function() {
            return function( id, treatments ) {
                var treatmentId;

                angular.forEach(treatments, function(categories) {
                    angular.forEach(categories.treatments.data, function(one_treatment) {
                        if(one_treatment.id == id){
                            treatmentId=one_treatment.id;
                        }
                    });
                });
                return treatmentId;
            }
        })*/

        // restituisce l'oggetto store dall'id
        .filter( 'getStoreFilter', function() {
            return function( id, stores ) {
                return _.find(stores, ['id', id]);
            }
        })


        // restituisce l'oggetto operator dall'id
        .filter( 'getOperatorFilter', function() {
            return function( id, users ) {
                return _.find(users, ['id', id]);
            }
        })


        // filtra tutti gli stores di una city data
        /*
        .filter( 'getCityStoresFilter', function() {
            return function( storesList , city ) {
                city = city.city;
                var cityStores = [];

                angular.forEach(storesList, function(store) {
                    if(store.city == city){
                        cityStores.push(store);
                    }
                });

                return cityStores;
            }
        })
        */


        // restituisce le city in base agli stores forniti   es. ['Imola', 'Bologna'...]
        .filter( 'getCitiesFilter', function() {
            return function( storesList ) {
                var cities = [];
                var unique_cities = [];

                angular.forEach(storesList, function(store) {
                    cities.push(store.city);
                });

                unique_cities = _.uniq(cities);
                return unique_cities;
            }
        })




        // restituisce solo l'ora da un datetime
        .filter( 'splitTimeFilter', function() {
            return function( datetime ) {
                var time ='';
                if (typeof datetime != "undefined") {
                    var partsOfStr = datetime.split(' ');
                    time = partsOfStr[1];
                }
                return time;
            }
        })
        // restituisce solo l'ora da un datetime
        .filter( 'dateTimeStringToLabel', function() {
            return function( datetime ) {
                var time = moment(datetime);
                return time.format('dddd, D MMMM');
            }
        })

        // spezza i prezzi con virgole
        .filter( 'labelRadioButtonFilter', function() {
            return function( label, type ) {
                var html='';

                if(type == 'euro' && label){
                    var partsOfStr = label.toString().split('.');
                    if(partsOfStr.length > 1){
                        html = '<span class="mini-txt mini-euro">€</span>'+partsOfStr[0]+'<span class="mini-txt">,'+partsOfStr[1]+'0<span>';
                    }else{
                        html = '<span class="mini-txt mini-euro">€</span>'+label.toString();
                    }
                }

                else if (type == 'long-txt') {
                    html = '<span class="two-lines-txt">'+label+'</span>';
                }

                else{
                   html=label;
                }

                return html;
            }
        })


        // restituisce il primo momento della giornata disponibile es. "morning"
        .filter( 'setFirstMomentFilter', function() {
            return function( dayMoments ) {
                var day_moment ='';
                var first = false;

                angular.forEach(dayMoments, function(this_moment) {
                    if(!this_moment.disabled && !first){
                        day_moment = this_moment.value;
                        first = true;
                    }
                });
                return day_moment;
            }
        })



        // restituisce il momento della giornata di una disponibilità es. "morning"
        .filter( 'getMomentFilter', function($filter) {
            return function( availability, dayMoments ) {
                var day_moment ='';
                var moment_start ='';
                var moment_end ='';
                var availability_start = moment($filter('splitTimeFilter')(availability.date_start), 'HH:mm');

                angular.forEach(dayMoments, function(this_moment) {
                    moment_start = moment(this_moment.start, 'HH:mm');
                    moment_end = moment(this_moment.end, 'HH:mm');

                    if(availability_start >= moment_start && availability_start < moment_end){
                        day_moment = this_moment.value;
                    }
                });
                return day_moment;
            }
        })


        // restituisce l'array delle disponibilità filtrato in base a che momento della giornata è stato passato (massimo 3 per momento ordinati per rilevanza e poi per ora)
        .filter( 'distributeAvailabilitiesInMomentsFilter', function($filter) {
            return function( availabilitiesList, dayMomentVal, dayMoments, customer ) {
                var filtered_list = [];
                var availability_moment ='';
                //var max_availabilities_per_moment = 3;
                //var count_availabilities_per_moment = 0;
                //ordino l'array per rilevanza al contrario (può anche non servire se l'array mi arriva già ordinato)
                //availabilitiesList = _.sortBy(availabilitiesList, function(o) { return o.relevance; }).reverse();
                //availabilitiesList = _.orderBy(availabilitiesList, function(o) { return o.relevance; },'desc');
                var dayMoment = $filter('filter')(dayMoments, {value: dayMomentVal}, true)[0];
                //controlla la disponibilità è nel momento ora attivo
                var last_min = -1;
                var last_c_comm = -1;
                angular.forEach(availabilitiesList, function(one_availability) {
                  var to_add = customer==null || customer.user_times>0; // se customer non settato o user_times>0 faccio vedere tutti
                  if (!to_add && (last_min!=one_availability.minute || one_availability.role.data.c_capability.comm>=last_c_comm)) {
                    to_add = true;
                    last_min = one_availability.minute;
                    last_c_comm = one_availability.role.data.c_capability.comm;
                  }
                  if (to_add) {
                    if (dayMomentVal==null || dayMomentVal=='') {
                        filtered_list.push(one_availability);
                    } else {
                        //availability_moment = $filter('getMomentFilter')(one_availability,dayMoments);
                        //aggiunge all'array a disponibilità
                        if(dayMoment.minute_start<=one_availability.minute && dayMoment.minute_end>one_availability.minute){
                            filtered_list.push(one_availability);
                        }
                    }
                  }
                });

                //ordino l'array per ora
                //filtered_list = _.orderBy(filtered_list, function(o) { return moment($filter('splitTimeFilter')(o.date_start), 'HH:mm') },'asc');

                return filtered_list;
            }
        })

        // restituisce i momenti della giornata con i relativi prezzi
        .filter( 'setDayMomentsFilter', function($filter) {
            return function( availabilitiesList, dayMoments ) {
                // console.log('DENTRO');
                var availability_moment ='';
                var no_availability = true;
                var dayMomentsChanged = [];
                angular.copy(dayMoments,dayMomentsChanged);

                // dayMoments = [
                // { value:'morning', label: '', description:'Mattina', icon: '', active: false, disabled:false, start: '09:00:00', end: '12:00:00', type:'euro' },
                // { value:'lunch', label: '', description:'Pausa Pranzo', icon: '', active: false, disabled:false, start: '12:00:00', end: '14:30:00', type:'euro' },
                // { value:'afternoon', label: '', description:'Pomeriggio', icon: '', active: false, disabled:false, start: '14:30:00', end: '17:00:00', type:'euro' },
                // { value:'evening', label: '', description:'Sera', icon: '', active: false, disabled:false, start: '17:00:00', end: '20:00:00', type:'euro' }
                // ];


                //ciclo ogni momento della giornata
                angular.forEach(dayMomentsChanged, function(one_moment) {

                    //controllo ogni disponibilitò ed alla prima di quel momento, setto il prezzo del momento
                    angular.forEach(availabilitiesList, function(one_availability) {
                        if(no_availability) {
                            availability_moment = $filter('getMomentFilter')(one_availability,dayMoments);

                            if(availability_moment ==  one_moment.value){
                                one_moment.label = one_availability.price;
                                no_availability = false;
                            }
                        }
                    });

                    //se per questo momento non ho trovato nessuna disponibilità, lo disabilito e resetto la variabile no_availability per il momento successivo
                    if(no_availability){
                        //console.log(one_moment);
                        one_moment.disabled = true;
                        one_moment.label = 'posti esauriti';
                        one_moment.type = 'long-txt';
                    }

                    no_availability = true;

                });

                return dayMomentsChanged;
            }
        })



})();


(function() {
    'use strict';

    angular
        .module('booking')
        .controller('BookingController', BookingController)
        .controller('BookingNotAuthorizedController', BookingNotAuthorizedController)
        .controller('BookingCompletedController', BookingCompletedController);

        /** @ngInject */
        function BookingController(
            env,
            $log,
            $location,
            $state,
            $auth,
            $filter,
            $http,
            ngDialog,
            Lightbox,
            $window,
            $document,
            $scope,
            $rootScope,
            callCenter,
            landing,
            customerId,
            firstname,
            leadId,
            tag,
            campagna,
            cusActId,
            storeId,
            treatmentId,
            appointmentId,
            appointmentDate,
            tenant,
            debug,
            kpiCheck,
            isUser,
            userRole,
            userSid,
            TreatmentService,
            StoreService,
            AppointmentService,
            UserService,
            TokenService,
            CustomerService,
            token,
            SubscriptionService,
            CustomerSubscriptionService,
            MyAvailabilityService,
            birthtime,
            source,
            couponCode,
            appCustomerId,
            utmSource,
            utmMedium,
            utmCampaign,
            utmGender,
            utmRegion,
            utmTreatment,
            utmAid,
            utmCreative,
            utmChannel,
            utmPricing,
            wkFlow,
            wkStateFrom,
            wkStateTo,
            wkEntityId,
            referral
        ) {
            var vm = this;
            // moment.locale('it');
            vm.env = env;
            vm.debug = debug;
            vm.wkFlow = wkFlow,
            vm.wkStateFrom = wkStateFrom;
            vm.wkStateTo = wkStateTo;
            vm.wkEntityId = wkEntityId;
            vm.referral = referral;
            $log.info("BookingController kpiCheck="+kpiCheck);
            vm.kpiCheck = (kpiCheck==null?true:(kpiCheck!='false' && kpiCheck!='0'));
            $log.info("BookingController kpiCheck="+vm.kpiCheck);
            vm.birthtime = null;
            vm.birthdate = null;
            vm.typeApp = "";
            vm.nearestBirthdate = function() {
                if (vm.birthdate.month() - moment().month() >= 10) {//accade solo 12 . 1 e 12 . 2 o 11 1
                    return moment(vm.birthdate).year(moment().year()-1);
                } else {
                    return moment(vm.birthdate).year(moment().year());
                }
            }
            if (birthtime) {
                vm.birthtime = birthtime;
                vm.birthdate = moment(birthtime*1000);

                /*$log.info("promo scaduta: "
                + ( moment().subtract(2,'month')
                    .isAfter( moment(vm.birthdate).year( moment().year() ) )
                  )
                );*/
                if (
                    moment().subtract(1,'months').isAfter(vm.nearestBirthdate())
                ) {
                    $state.go('booking-promo-expired');
                }
                vm.typeApp = 'free';
                //console.log("compleanno: "+ vm.birthdate.format('YYYY-MM-DD'));
            }
            vm.initialized = false;
            vm.tenantDataLoaded = false;
            vm.tenantFixed = false;
            if (vm.env.apis) {
                document.title = "Booking Italia";
                if (tenant && vm.env.apis[tenant]) {
                    vm.tenant = tenant;
                    vm.tenantFixed = true;
                    vm.currentAPI = vm.env.apis[tenant];
                    vm.currentAPILead = vm.env.apis[tenant];
                } else {
                    vm.currentAPI = vm.env.API;
                    vm.currentAPILead = vm.env.API;
                }
            } else {
                document.title = "Booking "+vm.env.tenant;
                vm.tenantFixed = true;
                vm.tenant = vm.env.tenant;
                vm.currentAPI = vm.env.API;
                vm.currentAPILead = vm.env.API;
            }
            vm.version = "3.2";
            vm.userRole = userRole;
            vm.source = source;
            vm.couponCode = couponCode;
            vm.appCustomerId = appCustomerId;
            vm.treatmentIdParam = treatmentId;
            vm.storeIdParam = storeId;
            vm.utms = {
                utmCampaign: 'utm_campaign',
                utmMedium: 'utm_medium',
                utmSource: 'utm_source',
                utmAid: 'utm_aid',
                utmGender: 'utm_gender',
                utmChannel: 'utm_channel',
                utmRegion: 'utm_region',
                utmCreative: 'utm_creative',
                utmPricing: 'utm_pricing',
                utmTreatment: 'utm_treatment'
            };
            vm.utmsValues = {
                utmCampaign: utmCampaign,
                utmMedium: utmMedium,
                utmSource: utmSource,
                utmAid: utmAid,
                utmGender: utmGender,
                utmChannel: utmChannel,
                utmRegion: utmRegion,
                utmCreative: utmCreative,
                utmPricing: utmPricing,
                utmTreatment: utmTreatment
            };
            // $log.info('BookingController cusActId=' + cusActId);
            // $log.info('BookingController userRole=' + userRole);
            /**
             * Utente loggato
             */
            vm.user = null;
            /**
             * Operatore e assistente per il trattamento
             */
            vm.operator = {id: null};
            vm.assist = {id: null};
            vm.commercial = {id: null};

            // DEFAULT
            vm.reservedEnabled = !vm.env.show || vm.env.show.filter_reserved;
            vm.newCustomer = function (phone) {
              return {
                firstname: firstname?firstname:null,
                lastname: null,
                phone: phone,
                birthdate: null,
                email: null,
                gender: null,
                referral_code: null,
                referral: vm.referral?vm.referral:null,
                source: vm.referral?'Referral':(!vm.isUser?'Booking':(vm.user.store_id?'Porta':'Commerciale')), //logica inizializzazione source
                overwritten_by_lead: 0,
                change_state_counter: 0,
                credit: 0,
                user_times: 0,
                app_times: 0,
                f_guarantee: 0,
                f_notyfy_wa: 1,
                f_notyfy_email: 0,
                f_notyfy_sms: 0,
              };
            }
            vm.customer = vm.newCustomer(null);

            vm.customerId = customerId;
            vm.treatmentId = treatmentId!=null?treatmentId:null;
            vm.treatmentPrice = null
            vm.storeId = storeId;
            vm.leadId = leadId;
            if (leadId) {
                vm.tag = tag && tag!='null'?tag:null;
                vm.campagna = campagna && campagna!='null' ? campagna: null;
                if (vm.env.apis && tenant && 'Italia'!=tenant) {
                    vm.currentAPILead = vm.env.apis[tenant];// per spostamento
                    // desiderata
                    vm.currentLeadTenant = tenant;
                } else {
                     vm.currentAPILead = vm.env.API;// per spostamento lead
                                                    // all'area desiderata
                     vm.currentLeadTenant = vm.env.apis?'Italia':vm.env.tenant;
                }
            }
            vm.cusActId = cusActId;
            vm.appointmentId = appointmentId;
            vm.cantChangeCustomer = vm.appointmentId!=null || vm.leadId!=null || customerId != null;
            vm.appointmentDate = appointmentDate;
            if (vm.appointmentId!=null) {
                $log.info("load app isUser: "+vm.isUser);
                if (vm.isUser) {
                    AppointmentService.get(appointmentId, {with: 'treatment'}, vm.currentAPI).then(function (data) {
                        vm.appointment = data;
                        vm.note = vm.appointment.note;
                    });
                } else {
                    AppointmentService.getAnon(appointmentId, {date_start: vm.appointmentDate, phone: vm.customerId, with: 'treatment'}, vm.currentAPI)
                    .then(function (data) {
                        $log.info(data);
                        vm.appointment = data;
                        vm.note = vm.appointment.note;
                    }, function(data) {
                        $log.error(data);
                        if (data.status == 401) {
                            $state.go('booking-notauthorized');
                        }

                    });
                }
            }
            /**
             * Id utente loggato
             */
            vm.operatorId = null;
            vm.isUser = vm.env.apis || isUser || env.anonymous_access === false;
            vm.isCallCenter = callCenter;
            $log.info("isCallCenter: " + callCenter);
            /*
             * Viene inializzato su logon
             */
            vm.priceFromSubscription = false;
            vm.note = '';
            vm.token = token;
            // Landing page
            if( landing) {
                vm.landing = landing;

                if( vm.landing.treatment_id ){
                    vm.treatmentId = landing.treatment_id;
                }
                if( vm.landing.price ){
                    vm.treatmentPrice = landing.price;
                }
            }
            // steps
            $scope.$watch('booking.isClient', function(newValue) {
                if(false && !newValue){
                    vm.isClientStep = 1;
                    vm.treatmentsStep = 2;
                    vm.storesStep = 3;
                    vm.dateTimeStep = 4;
                    vm.customerDataStep = 5;
                    vm.totalStep = 5;
                } else if (vm.isUser || vm.referral) {
                    if (vm.referral) {
                        //vm.isClientStep = 1;
                        vm.treatmentsStep = 2;
                        vm.storesStep = 3;
                        vm.dateTimeStep = 4;
                        vm.customerDataStep = 1;
                        vm.totalStep = 4;
                    } else {
                        vm.isClientStep = 1;
                        vm.treatmentsStep = 3;
                        vm.storesStep = 4;
                        vm.dateTimeStep = 5;
                        vm.customerDataStep = 2;
                        vm.totalStep = 5;
                    }
                } else if (vm.birthdate) {
                    vm.storesStep = 1;
                    vm.dateTimeStep = 2;
                    vm.customerDataStep = 3;
                    vm.totalStep = 3;
                } else {
                    vm.treatmentsStep = 3;
                    vm.storesStep = 4;
                    vm.dateTimeStep = 5;
                    vm.isClientStep = 1;
                    vm.customerDataStep = 2;
                    vm.totalStep = 5;
                }
            },true);

            // ---------- tenantsList ----------------------------------//
            vm.tenantsList = [];
            if (vm.env.apis) {
                angular.forEach(vm.env.apis, function(value, key) {
                    vm.tenantsList.push(
                            { value: key, label:key.substring(0,2).toUpperCase(), description:'', icon: '', active: false, disabled:false }
                    );
                });
            }

            // ---------- isClient -------------------------------------//
            vm.isClient = false;
            vm.isClientTitle = 'Sei già cliente <span>'+env.company+'</span>? *';
            vm.isClientList = [
                { value: true, label:'SI', description:'', icon: '', active: false, disabled:false },
                { value: false, label:'NO', description:'', icon: '', active: false, disabled:false }
            ];
            // vm.isClientList =
            // $filter('setActiveRadioButtonFilter')(vm.isClient,vm.isClientList);

            vm.setUserAlias = function (elem, user) {
              elem.user_alias = "";
              elem.user_alias = ((user.firstname!=null?user.firstname:'')+'   ').substring(0,3).trim();
              elem.user_alias += '.';
              elem.user_alias += ((user.lastname!=null?user.lastname:'')+'   ').substring(0,3).trim();
            };


            // ---------- treatments -------------------------------------//
            // treatments
            vm.treatmentsTitle = 'Scegli il <span>servizio</span> *';
            if(vm.landing){
                vm.treatmentsTitle = 'Dettagli del <span>servizio</span>';
                // genders
                if( ! vm.landing.treatment_id ){
                    vm.gender = 'F';
                }
            }

            vm.gendersList = [
                { value:"F", text:'', description:'Donna', icon: 'icon-woman' },
                { value:"M", text:'', description:'Uomo', icon: 'icon-man' }
                /*,
                Unisex si vedono sempre
                { value:"U", text:'', description:'Unisex', icon: 'icon-people' },
                */
            ];

            vm.typeAppList = [
                { value: "", text:'', description:'Prezzo pieno', icon: 'icon-attach_money', active: 1},
                { value:"promo", text:'', description:'Promo', icon: 'icon-input' },
                { value:"free", text:'', description:'Omaggio', icon: 'icon-money_off' }
            ];


            vm.subscriptionsList = [];
            // if (appointmentId == null) {
                SubscriptionService.all( {}, vm.currentAPI ).then(function( response ){
                    vm.subscriptionsList = response.data.data;
                });
            // }

            vm.sourcesList = null;
            if (vm.isUser && userRole!='operator' && userRole!='storemngr') {
                var apiURI = env.API + '/customer-sources'; // uso API tanto va
                                                            // su com
                $http.get( apiURI ).then(function( response ){
                    // $log.info(response);
                    vm.sourcesList = response.data.data;
                    // $log.info(vm.sourcesList);
                });
            }

            vm.config = {
                'data': {},
                'get': function(key,defaultValue) {
                    return this.data[key]?this.data[key]:defaultValue;
                }
            };
            var apiURI = env.API + '/config/booking'; // uso API tanto va su
                                                        // com
            $http.get( apiURI ).then(function( response ){
                vm.config.data = response.data;
            });

            // setta il sesso del cliente al cambio di genere
            $scope.$watch('booking.gender', function() {
                vm.customer.gender = vm.gender;
            },true);


            /**
             * Filtro trattamenti TODO
             */
            /*
             * vm.treatmentFilter = undefined; vm.treatmentFilterOptionsList = [ {
             * value:undefined, label: '', description:'Tutti', icon: '',
             * active: true, disabled:false, start: '', end: '', type:'' }, ];
             * vm.isRullo = cusActId!=null; if (vm.isRullo) {
             * vm.treatmentFilterOptionsList.push({ value: 'PROMO', label: '',
             * description:'Promo', icon: '', active: false, disabled:false,
             * start: '', end: '', type:'' }); } else {
             * vm.treatmentFilterOptionsList.push({ value: 'GP', label: '',
             * description:'Groupon', icon: '', active: false, disabled:false,
             * start: '', end: '', type:'' }); } vm.allTreatmentsList = [];
             * vm.treatmentFilterSelected = function() { if (vm.treatmentFiter ==
             * undefined) { vm.treatmentsList = vm.allTreatmentsList; } else if
             * (vm.treatmentFiter=='GP') { angular.forEach(vm.allTreatmentsList,
             * function(tc) { var tmp = []; angular.forEach(tc.treatments.data,
             * function(t) { if (t.name.endsWith(" GP")) { tmp.push(t); } });
             * tc.treatments.data = tmp; }); } };
             */
            vm.back = function () {
              if (vm.isUser) {
                if (vm.leadId!=null) {
                  window.location = env.admin + "/lead" + (vm.env.tenant=='Italia'?'':'s');
                } else if (vm.cusActId != null) {
                  window.location = env.admin + "/cusacts";
                } else {
                  window.history.back();
                }
              }
            };

            /**
             * Gestione funzioni multiarea
             */
            vm.confirmTenant = function() {
                vm.loading = true;
                // TODO reset caricamento dati app
                $log.info("confirmTenant: " + vm.tenant + " -> " + vm.currentAPI + ' -> ' + vm.currentAPILead);
                if (vm.leadId && vm.env.apis && vm.currentLeadTenant!=vm.tenant) {
                    vm.tenantMsg = "Spostamento lead da " + vm.currentLeadTenant + " a "+vm.tenant+"...";
                    // invio lead al tenant poi carico dati cliente
                    var updObj = { id: vm.leadId, move_to: vm.tenant, c_role: vm.user.type, c_sid: vm.user.store_id };
                    $http.put( vm.currentAPILead+'/leads/'+updObj.id, updObj ).then(
                            function (response) {
                                // $log.info(response);
                                vm.currentLeadTenant = response.data.data.response.tenant;
                                if (vm.tenant!=vm.currentLeadTenant) {
                                    vm.tenantMsg = "Trovato lead in " + vm.currentLeadTenant + ", spostamento lead da " + vm.currentLeadTenant + " a " + vm.tenant;
                                    vm.currentAPILead = vm.env.apis[vm.currentLeadTenant];
                                    vm.leadId = response.data.data.response.lead_id;
                                    updObj.id = vm.leadId;
                                    $http.put( vm.currentAPILead+'/leads/'+updObj.id, updObj ).then(
                                            function(response) {
                                                vm.currentAPI = vm.env.apis[vm.tenant];
                                                vm.currentAPILead = vm.env.apis[vm.tenant];
                                                vm.leadId = response.data.data.response.lead_id;
                                                vm.currentLeadTenant = response.data.data.response.tenant;
                                                $log.info("confirmTenant [newLeadId]: "+vm.leadId);
                                                vm.tenantMsg = "Lead spostato su "+ vm.tenant + " lead id = "+vm.leadId;
                                                vm.customer.phone = vm.customerId;
                                                vm.checkCustomer();
                                                vm.loadStores();
                                            },
                                            function (response) {
                                                $log.error(response);
                                                vm.tenantMsg = response.data.message;
                                            }
                                    );
                                } else {
                                    vm.currentAPI = vm.env.apis[vm.tenant];
                                    vm.currentAPILead = vm.env.apis[vm.tenant];
                                    vm.leadId = response.data.data.response.lead_id;
                                    vm.tenantMsg = "Lead spostato su "+vm.tenant + " lead id = "+vm.leadId;
                                    $log.info("confirmTenant [newLeadId]: "+vm.leadId);
                                    vm.customer.phone = vm.customerId;
                                    vm.checkCustomer();
                                    vm.loadStores();
                                }
                            },
                            function (response) {
                                $log.error(response);
                                vm.tenantMsg = response.data.message;
                            });
                } else {
                    if (vm.env.apis) {
                        vm.currentAPI = vm.env.apis[vm.tenant];
                        vm.currentAPILead = vm.env.apis[vm.tenant];
                    } else {
                        vm.currentAPI = vm.env.API;
                        vm.currentAPILead = vm.env.API;
                    }
                    if (vm.customer && vm.customer.id) {
                        vm.checkCustomer();
                    } else if (vm.customerId && !vm.isUser) {
                        vm.customer.phone = vm.customerId;
                        vm.checkCustomer();
                    }
                    vm.loadStores();
                }
            }
            vm.changeTenant = function() {
                vm.tenantMsg = "";
                vm.tenantDataLoaded = false;
                vm.treatmentsList = [];
                vm.storesList= [];
                vm.rolesList = [];
                vm.monthAvailability.reset();
                vm.customer = vm.newCustomer(null);
                delete vm.store;
            }

            /**
             * Carico trattamenti e filtro solo pubblici o escludoPromo oppure
             * tutte se sono da rullo
             */
            vm.treatmentsList = [];
            vm.treatmentsListPlain = [];
            vm.treatmentsListAll = {};
            vm.search_treatmnent = null;
            vm.loadingTreatments = false;
            vm.treatmentsLoaded = false;
            vm.loadTreatments = function() {
                vm.loadingTreatments = true;
                vm.treatmentsList = [];
                vm.treatmentsListPlain = [];
                vm.treatmentsListAll = [];
                vm.tenantMsg = "Caricamento trattamenti " + vm.tenant + " ...";
                TreatmentService.categories(vm.currentAPI).then(function(data) {
                    vm.treatmentsList = [];
                    vm.treatmentsListPlain = [];
                    /*
                     * angular.forEach(data, function(tc) { var tcc = [];
                     * angular.forEach(tc, function(trt) { var tmp = {};
                     * angular.copy(trt,tmp); tcc.push(tmp); });
                     * vm.treatmentsListAll.push(tcc); });
                     */
                    angular.copy(data,vm.treatmentsListAll);

                    if (vm.customer.appointments && vm.customer.appointments.data) {
                        angular.forEach(vm.customer.appointments.data,function(app){
                            var trt = $filter('getTreatmentFilter')(vm.treatmentsListAll,app.treatment_id,true);
                            if (trt==null) {
                                trt = {id: app.treatment_id, name:'Trattamento non trovato [tid='+app.treatment_id+']'}
                            }
                            app.treatment = {'data': trt};
                            angular.forEach(vm.storesList, function(store) {
                                if (app.store_id == store.id) {
                                    app.store = {'data': store};
                                }
                            });
                        });
                    }

                    vm.tenantMsg = "Caricamento trattamenti " + vm.tenant + " ... fatto!";

                    /*
                     * if (!vm.isUser) { // utente normale tolgo i privati
                     * angular.forEach(data, function(tc) { var tmp = [];
                     * angular.forEach(tc.treatments.data, function(t) { if
                     * (!t.private) { tmp.push(t); } }); tc.treatments.data =
                     * tmp; }); } else {//logiche filtro promo/GP
                     */
                      var excludePromo = (vm.appointmentId == null && vm.cusActId==null)
                                      || (vm.appointment!=null && !vm.appointment.treatment.data.name.endsWith(" Promo"));
                      var excludeGP = vm.appointmentId != null && vm.appointment!=null && !vm.appointment.treatment.data.name.endsWith(" GP")
                      var filterCategory = vm.storeId && vm.env.stores && vm.env.stores[vm.storeId] && vm.env.stores[vm.storeId].categories;
                      var firstTreatmentId = null;
                      var firstTreatmentCategoryId = null;
                      var existTreatmentId = false;
                      var tmpPlain = [];
                      angular.forEach(data, function(tc) {
                            var tmp = [];
                            // console.log("controllo incluse: "+tc.id);
                            // console.log("store: "+vm.storeId);
                            if (filterCategory) {
                            // console.log(vm.env.stores[vm.storeId]);
                            // console.log(vm.env.stores[vm.storeId].categories);
                            }
                            if (!filterCategory || vm.env.stores && vm.env.stores[vm.storeId].categories.includes(tc.id)) {
                                tc.treatments.data = $filter('orderBy')(tc.treatments.data,['order','name']);
                                angular.forEach(tc.treatments.data, function(t) {
                                    //if (vm.tag && t.tag == vm.tag) {
                                        //$log.info("Trattamento TAG: "+t.name + " [tag="+t.tag+"] " + " [tid="+t.id+"] / "+t.treatment_category_id);
                                    //}
                                    if ((vm.treatmentId && vm.treatmentId == t.id)
                                        || (vm.tag && vm.tag == t.tag)
                                        || (vm.birthdate && t.f_birthday)
                                        || (!vm.birthdate && t.active && t.f_book
                                            && (t.f_first_time == null || t.f_first_time == (vm.user_times<1)))) {
                                        if (    (vm.treatmentId && vm.treatmentId == t.id)
                                                || (vm.tag && vm.tag == t.tag)
                                                || (!vm.isUser && !t.private)
                                                || (vm.isUser && t.promo && !excludePromo)
                                                || (vm.isUser && t.name.endsWith(" GP") && !excludeGP)
                                                || (vm.isUser && !t.promo && !t.name.endsWith(" GP"))
                                        ) {
                                            if (!firstTreatmentId
                                                    && (!filterCategory
                                                        || !vm.env.stores[vm.storeId].firstTreatmentId
                                                        || vm.env.stores[vm.storeId].firstTreatmentId)) {
                                                if ((vm.gender == t.gender || t.gender == 'U') && (vm.user && vm.user.id || !t.private)) {//trattamento selezionato inizialmente
                                                    firstTreatmentId = t.id;
                                                }
                                            }
                                            if (vm.treatmentId && t.id == vm.treatmentId) {
                                                existTreatmentId = true;
                                            } else if (!vm.treatmentId && vm.tag && t.tag == vm.tag) {
                                                existTreatmentId = true;
                                                vm.treatmentId = t.id;
                                                vm.search_treatment = t.name;
                                            }
                                            tmp.push(t);
                                            tmpPlain.push(t);
                                            //$log.info("Trattamento incluso: "+t.name + " [tag="+t.tag+"] " + " [tid="+t.id+"] / "+t.treatment_category_id);
                                        } else {
                                            //$log.info("Trattamento escluso per private gp promo: "+t.name + " [tag="+t.tag+"] " + " [tid="+t.id+"] / "+t.treatment_category_id);
                                        }
                                    } else {
                                        //$log.info("Trattamento escluso per book user_times: "+t.name + " [tag="+t.tag+"] " +  " [tid="+t.id+"] / "+t.treatment_category_id);
                                    }
                                });
                            }
                            tc.treatments.data = tmp;
                      });
                      if (!existTreatmentId) {
                          vm.treatmentId = firstTreatmentId;
                      }
                    // }
                    vm.treatmentsList = data;
                    vm.treatmentsListPlain = tmpPlain;
                    // vm.allTreatmentsList = data;
                    if( vm.landing ) {
                        if( ! vm.landing.treatment_id ){
                            vm.gendersList = $filter('setGendersFilter')(vm.treatmentsList, vm.gendersList);
                            vm.gendersList = $filter('setActiveRadioButtonFilter')(vm.gender,vm.gendersList);
                        }
                    }
                    vm.treatment = $filter('getTreatmentFilter')(vm.treatmentsList,vm.treatmentId);
                    if (vm.treatment) {
                        if (vm.landing && !vm.treatment.active) {
                            $state.go('booking-promo-expired');
                            return;
                        }
                        vm.active_treatment_category_id = vm.treatment.treatment_category_id;
                    }
                    vm.priceOverride = vm.getTreatmentPrice();
                    if (vm.active_treatment_category_id!=vm.treatment.treatment_category_id) {
                        vm.active_treatment_category_id = vm.treatment.treatment_category_id;
                    }
                    vm.buildCapabilities();
                    vm.loadingTreatments = false;
                    vm.treatmentsLoaded = true;
                    vm.buildCustomerAppointments();
                    if (vm.landing) {
                        if (!vm.user) {
                            vm.monthAvailability.load();
                        } else {
                            $log.info("landing ma cè user");
                        }
                    }
                    console.log("Booking active treatment category id: " + vm.active_treatment_category_id);
                },
                function(response) {
                    $log.error(response);
                    vm.tenantMsg = response.data.message;
                    vm.loading = false;
                });
            }
            $scope.$watch('booking.treatmentId', function(newValue, oldValue) {
                if(newValue !== oldValue){
                    vm.monthAvailability.reset();
                    vm.treatment = $filter('getTreatmentFilter')(vm.treatmentsList,vm.treatmentId);
                    vm.priceOverride = vm.getTreatmentPrice();
                    vm.buildCapabilities();
                    vm.isOver = false;
                }
            },true);

            $scope.$watch('booking.typeApp', function(newValue, oldValue) {
                var selectedOld = $filter('filter')(vm.typeAppList, {'value': oldValue}, true);
                var selected = $filter('filter')(vm.typeAppList, {'value': newValue}, true);
                if (selected && selected.length==1) {
                    selected[0].active = 1;
                }
                if (oldValue!=newValue && selectedOld && selectedOld.length==1) {
                    selectedOld[0].active = 0;
                }
                vm.priceOverride = vm.getTreatmentPrice();
            },true);

            vm.getTreatmentPrice = function () {
                if (!vm.treatment) { return; }
                if (vm.customer_subscription_id) {
                    return vm.customerSubscriptionIdChange();
                }
                if (vm.subscription_new_id) {
                    return vm.subscriptionNewIdChange();
                }
                if (!vm.typeApp) {
                    return vm.treatment.start_price;
                } else if (vm.typeApp == 'promo') {
                    if (vm.treatment.promo_price) {
                        return vm.treatment.promo_price;
                    } else {
                        return Math.round(vm.treatment.start_price*0.75);
                    }
                } else if (vm.typeApp == 'free') {
                    return 0;
                }
            };

            vm.buildCapabilities = function () {
                var t = vm.treatment;
                if (!t) return;
              /**
                 * devo aggiornare le capabilities
                 */
              angular.forEach(vm.rolesList, function (role) {
                role.c_capability = {comm: 1, man: 1, rel: 1};

                if (t.capability_id!=null) {
                  angular.forEach(role.capabilities, function (cap) {
                    if (cap.capability_id == t.capability_id) {
                      role.c_capability = cap;
                    }
                  });
                }
                if (role.c_capability.man>0) {
                    role.treatmentEnabled = true;
                } else {
                    role.treatmentEnabled = false;
                }
                /**
                 * aggiorno dati reddh
                 */
                role.c_capability.reddh = 0;
                role.c_capability.check_m_pond = 0;
                role.c_capability.max_daily_app = null;
                if (role.kpis && role.kpis.length>0) {
                    angular.forEach(role.kpis, function(kpi){
                        if (kpi.f_first_time == (vm.user_times<1)
                                && kpi.treatment_category_id == t.treatment_category_id
                                && kpi.store_id == vm.storeId) {
                            role.c_capability.reddh = parseInt(kpi.reddh);
                            role.c_capability.check_m_pond = parseInt(kpi.check_m_pond);
                            role.c_capability.max_daily_app = (''+kpi.max_daily_app=='null'?null:parseInt(kpi.max_daily_app));
                        }
                    });
                }
              });
            };
            /*
             * vm.sortByReddh = function (role) { var val = 0; if
             * (role.c_capability && role.c_capability.reddh) { val =
             * parseInt(role.c_capability.reddh); }
             * $log.info(role.user.firstname + " "+val); return val; }
             */
            // ---------- stores -------------------------------------//

            vm.titleStoreArticle = 'del';
            vm.titleStore = 'centro estetico';
            vm.titleCustomer = 'cliente';
            vm.storesTitle = 'Scegli il <span>'+vm.titleStore+'</span> *';
            if( vm.landing ) {
                if( vm.landing.stores.data.length === 1 ){
                    vm.storesTitle = 'Dettagli '+vm.titleStoreArticle+' <span>'+vm.titleStore+'</span>';
                };
            };

            vm.storesList= [];
            vm.rolesList = [];
            vm.loadStores = function() {
                vm.loadingTreatments = true;
                var opts = {with:'roles'};
                /*
                 * if (appointmentId != null) { opts.searchFields = 'id:=';
                 * opts.search = storeId; }
                 */
                vm.tenantMsg = "Caricamento centri " + vm.tenant + " ...";
                StoreService.all(opts, vm.currentAPI).then(function(data){
                    vm.tenantMsg = vm.tenantMsg = "Caricamento centri " + vm.tenant + " ... fatto!";
                    vm.storesList = data;
                    if( vm.landing ) {
                        if(vm.landing.stores.data.length){
                            vm.storesList = vm.landing.stores.data;
                        }
                    }

                    // city stores
                    vm.citiesList = $filter('getCitiesFilter')(vm.storesList);
                    vm.city = vm.citiesList[0];

                    // se non è stato passato nessuno store da url, setto il
                    // primo della lista
                    if(!vm.storeId){
                        vm.store = $filter('filter')(vm.storesList, {active: 1, booking_online: 1}, true)[0];
                        if (vm.store) {
                            vm.storeId = vm.store.id;
                        }
                    } else {
                        vm.store = $filter('getStoreFilter')(vm.storeId, vm.storesList);
                    }
                    if (vm.user!=null && vm.user.store_id) {
                      vm.user.store = $filter('getStoreFilter')(vm.user.store_id, vm.storesList);
                    }
                    if( vm.store && vm.store.id && vm.store.roles && vm.store.roles.data) {
                        vm.storeId = vm.store.id;
                        var op = $filter('filter')(vm.store.roles.data, {'role': 'operator', 'active': true}, true);
                        var sm = $filter('filter')(vm.store.roles.data, {'role': 'storemngr', 'active': true}, true);
                        vm.rolesList = op.concat(sm);
                        // $log.info(vm.rolesList);
                    };
                    vm.loadTreatments();
                    vm.buildCapabilities();
                    // vm.search(true);
                    vm.tenantDataLoaded = true;
                    vm.loading = false;
                });
            };

            /**
             * Confirm tenant usa checkcustomer che va definita sopra
             */
             vm.checkCustomer = function() {
                vm.referralCan = true;
                vm.existLeadComm = false;
                vm.referralShowMsgLink = true;
                if (vm.customer.phone == null || vm.customer.phone.trim()=='') return;
                vm.customerChecking = true;
                vm.customerLoaded = false;
                vm.old_user_times = vm.user_times;
                /**
                   * Devo eseguire solo se il cell è valido
                   */
                // $log.info("checkCustomer: " + vm.customer.phone);
                if (vm.customer.id!=null) {// tengo solo il telefono
                  var phone = vm.customer.phone;
                  vm.customer = vm.newCustomer(phone);
                }
                vm.tenantMsg = "Caricamento dati "+vm.titleCustomer+" ...";
                var pars = {'phone':vm.customer.phone};
                if(vm.birthdate) {
                  pars.search+=';birthdate:'+vm.birthdate.format('YYYY-MM-DD');
                  pars.searchFields+=';birthdate:=';
                }
                if (vm.isUser || vm.birthdate || vm.referral) {
                  pars.with = 'leads;leads.user;leads;leads.user;appointments;customer_subscriptions;sourceCustomer';
                }
                  CustomerService.all(pars, vm.currentAPI).then(
                    function(data) {
                      vm.customerChecking = false;
                      vm.tenantMsg = "Caricamento dati "+vm.titleCustomer+" ... fatto!";
                      if(data.length >= 1) {
                          vm.customer = data[0];
                          if (vm.customer.f_guarantee) {
                              vm.customer.guarantee_at_frmt = moment(vm.customer.guarantee_at).format('DD/MM/YY');
                          }
                          vm.customer.f_notyfy_wa = vm.customer.f_notyfy_wa || (!vm.customer.f_notyfy_email && !vm.customer.f_notyfy_sms) ? 1 : 0;
                          vm.customer.f_notyfy_email = vm.customer.f_notyfy_email ? 1 : 0;
                          vm.customer.f_notyfy_sms = vm.customer.f_notyfy_sms ? 1 : 0;
                          vm.buildCustomerAppointments();
                          if (vm.referral || vm.isUser && vm.user.store_id &&
                              !vm.appointmentId &&
                              !vm.haveAppointmensPaid(120) &&
                              !vm.haveSubscriptionActive()) {//lo spostamento è escluso
                              vm.checkLeadExist();
                              //verifica esistenza lead commerciale recente non chiuso
                          }
                          vm.customerLoaded = true;
                          if (vm.tenant) {
                              var options = {
                                  with : 'subscription;quotation',
                                  search :
                                      'customer_id:' + vm.customer.id +
                                      ';app_remaining:1'
                                  ,
                                  searchFields : 'customer_id:=;app_remaining:>='
                              };
                              var customer_subscriptions_active = [];
                              CustomerSubscriptionService.all(options, vm.currentAPI).then(function(response){
                                  angular.forEach( response.data.data, function( elem ) {
                                      if((elem.customer_id == vm.customer.id) && (elem.app_remaining >= 1)) {
                                          customer_subscriptions_active.push(elem);
                                      }
                                  });

                                  vm.customer.customer_subscriptions_active = customer_subscriptions_active;
                              });
                          }
                          vm.customer.birthdate = vm.customer.birthdate ? new Date( vm.customer.birthdate ) : null;
                          vm.isClientList = $filter('setActiveRadioButtonFilter')(true, vm.isClientList);
                          vm.gender = vm.customer.gender;
                          vm.gendersList = $filter('setActiveRadioButtonFilter')(vm.gender, vm.gendersList);
                      } else {
                        vm.isClientList = $filter('setActiveRadioButtonFilter')(false, vm.isClientList);
                        vm.gender = null;
                        vm.gendersList = $filter('setActiveRadioButtonFilter')(null, vm.gendersList);
                      }
                      /**
                        * setto referral se non presente
                      */
                      if (vm.referral) {
                        vm.customer.src_phone = vm.referral;
                      }
                      vm.customerLoaded = true;
                      vm.user_times = vm.customer.user_times;
                      vm.user_times_descr = (vm.user_times<1) ? 'Primo ingresso': 'Smaltimento';
                      /**
                       * Aggiungo messaggi controlli referral
                       * 1) Non cè appuntamento futuro
                       * 2) Non è già presente un lead
                       * 3) Clienti non presenti in database
                       * 4) Clienti che non si sono mai presentati
                       * 5) Clienti che non si sono presentati da almeno un anno
                       * 6) Clienti che sono referenziati da non più di un anno (quindi va aggiunta la data in cui imposto il src_cid) //TODO
                       */
                      if (vm.customer && vm.customer.id) {//i controlli vanno fatti anche nel booking operator
                        var futureApp = vm.haveFutureAppointmens();
                        if (futureApp) {
                            var fad = moment(futureApp.date_start);
                            vm.referralMsg = "Presente appuntamento futuro: "+fad.format('DD/MM/YYYY HH:mm');
                            vm.referralMsgDetail = "<h2>Hai già un appuntamento prenotato, presentati il giorno "+fad.format('DD/MM/YYYY')+" alle ore "+fad.format('HH:mm')+" e potrai aderire anche tu al progetto referral.</h2>";
                            vm.referralCan = false;
                            if (vm.referral) {
                                vm.existLeadComm = {id: null};
                            } else {
                                vm.customer.scr_phone = null;
                            }
                        }
                        if (vm.referralCan && vm.existLeadComm) {
                            var cdate = vm.customer.created_at.date?vm.customer.created_at.date:vm.customer.created_at;
                            if (moment(cdate).isBefore(moment().subtract(10, 'days')) && vm.existLeadComm.user) {
                                vm.referralMsg = "Promozione già attivata";
                                vm.referralMsgDetail = "<h2>Hai già una promozione attiva, per poter partecipare al progetto referral contatta il tuo consulente "+ vm.existLeadComm.user.data.firstname +" al n. <a href='tel:"+vm.existLeadComm.user.data.phone+"'>"+vm.existLeadComm.user.data.phone+"</a><h2>";
                                vm.referralCan = false;
                                if (!vm.referral) {
                                    vm.customer.scr_phone = null;
                                }
                            } else {
                                if (vm.referral) {
                                    vm.existLeadComm = null;
                                }
                            }
                        }
                        if (vm.referralCan && vm.existLeadRef) {
                            vm.referralMsg = "Promozione già attivata";
                            vm.referralMsgDetail = "<h2>Hai già una promozione attiva, per poter partecipare al progetto referral contatta il centro di "+ vm.store.alias +" al n. <a href='tel:"+vm.store.phone+"'>"+vm.store.phone+"</a><h2>";
                            vm.referralCan = false;
                            if (!vm.referral) {
                                vm.customer.scr_phone = null;
                            } else {
                                vm.existLeadComm = {id: null};
                            }
                        }
                        if (vm.referralCan && vm.haveAppointmensPaid(365000)) {
                            /** va ordinato desc */
                            vm.referralMsg = "Presente appuntamento nel passato."
                            vm.referralMsgDetail = "<h2>Contatta il nostro centro di "+vm.store.city+" al numero <a href='tel:"+vm.store.phone+"'>"+vm.store.phone+"</a> per poter segnalare i tuoi amici e vincere un viaggio!</h2>";
                            //Clicca nel link per ricevere il messaggio da inoltrare ai tuoi amici e poter partecipare al progetto referral, potrai vincere un meraviglioso viaggio.</h2>";
                            vm.referralCan = false;
                            vm.referralShowMsgLink = true;
                            if (vm.referral) {
                                vm.existLeadComm = {id: null};
                            } else {
                                vm.customer.scr_phone = null;
                            }
                        }
                        /**
                         * da booking va fatto check su cambio referral BS-154 //TODO
                         * Nuova implementazione: Non deve essere possibile fare cambio referral!!!
                         */
                        if (vm.referral && vm.referralCan && vm.customer.src_cid && vm.customer.sourceCustomer.data.phone!=vm.referral) {
                            //if ( (vm.customer.src_cid_at).isBefore(moment().subtract(365, 'days')) ) {
                                //posso procedere
                            //} else {
                                vm.referralMsg = "Cliente già referenziato da numero diverso da quello inserito: "+vm.customer.sourceCustomer.data.phone;
                                vm.referralMsgDetail = "";
                                vm.referralCan = false;
                                //vm.customer.scr_phone = null;
                                if (vm.referral) {
                                    vm.existLeadComm = {id: null};
                                } else {
                                    vm.customer.scr_phone = null;
                                }
                            //}
                        }
                    }

                      if (vm.tenant) {
                          vm.buildCapabilities();
                          if (vm.isUser &&
                                  (vm.user_times<1 && vm.old_user_times>=1
                                  || vm.user_times>=1 && vm.old_user_times<1)
                              ) {
                              // devo resettare le disponibilità caricate
                              // e i trattamenti perchè user_times è cambiato
                              vm.loadTreatments();
                              vm.monthAvailability.reset();
                          }
                      }
                 },
                   function (data) {
                      var msg = vm.getErrorMsg(data);
                      if (!vm.isUser) {
                          $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                              .then(
                                  function() {},
                                  function() {}
                          );
                      }
                      alert ( "C'è stato un problema nel caricamento dei dati del "+vm.titleCustomer+"." + (msg!=null?" " +msg:""));
                      vm.customerChecking = false;
                   }
                 );
              };

              vm.srcCustomer = null;
              vm.checkSrcCustomer = function() {
                vm.srcCustomerLoaded = false;
                console.log("checkSrcCustomer: ", vm.customer);
                if (vm.customer.src_phone == null || vm.customer.src_phone.trim()=='') {
                    return;
                }
                vm.srcCustomerChecking = true;
                if (!vm.srcCustomer || !vm.srcCustomer.id) {// tengo solo il telefono
                  var phone = vm.customer.src_phone;
                  vm.srcCustomer = vm.newCustomer(phone);
                }
                var phone = vm.srcCustomer.phone?vm.srcCustomer.phone:vm.customer.src_phone;
                var pars = {'phone':phone};
                console.log("CustomerService.all", pars, vm.currentAPI);
                CustomerService.all(pars, vm.currentAPI).then(
                    function(data) {
                      vm.srcCustomerChecking = false;
                      vm.srcCustomerLoaded = true;
                      console.log("all checkSrcCustomer", data);
                      if(data.length >= 1) {
                          vm.srcCustomer = data[0];
                          vm.isClientList = $filter('setActiveRadioButtonFilter')(true, vm.isClientList);
                          vm.gender = vm.customer.gender;
                          vm.gendersList = $filter('setActiveRadioButtonFilter')(vm.gender, vm.gendersList);
                      }
                    },
                    function (data) {
                        var msg = vm.getErrorMsg(data);
                        if (!vm.isUser) {
                            $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                                .then(
                                    function() {},
                                    function() {}
                            );
                        }
                        alert ( "C'è stato un problema nel caricamento dei dati." + (msg!=null?" " +msg:""));
                        vm.srcCustomerChecking = false;
                        vm.srcCustomerLoaded = true;
                    }
                );
            };

            if (!vm.env.apis || vm.tenant) {
                vm.confirmTenant();
            }

            /**
             * Per controllo cambio segnalente da booking operator
             */
            vm.checkReferralChange = function(referralPhone) {
                if (vm.referralCan && vm.customer.src_cid && vm.customer.sourceCustomer && vm.customer.sourceCustomer.data && vm.customer.sourceCustomer.data.phone!=referralPhone) {
                    //if ( (vm.customer.src_cid_at).isBefore(moment().subtract(365, 'days')) ) {
                        //posso procedere
                    //} else {
                        vm.referralMsg = "Cliente già referenziato da numero diverso da quello inserito: "+vm.customer.sourceCustomer.data.phone;
                        vm.referralMsgDetail = "";
                        vm.referralCan = false;
                        //vm.customer.scr_phone = null;
                        if (vm.referral) {
                            vm.existLeadComm = {id: null};
                        } else {
                            vm.customer.scr_phone = null;
                        }
                    //}
                }
            };

            vm.storeSelected = function() {
                vm.storeId = vm.store.id;
                var op = $filter('filter')(vm.store.roles.data, {'role': 'operator', 'active': true}, true);
                var sm = $filter('filter')(vm.store.roles.data, {'role': 'storemngr', 'active': true}, true);
                vm.rolesList = op.concat(sm);
                vm.operator = {id: null};
                vm.assist = {id: null};
                vm.commercial = {id: null};
                if (vm.env.stores) {
                    vm.loadTreatments();
                }
                vm.monthAvailability.reset();
                vm.buildCapabilities();
            };

            vm.operatorSelected = function(){
                vm.operator.role = $filter('filter')(vm.rolesList, {store_id: vm.store.id, user_id: vm.operator.id},true)[0];
                if (!vm.isOver) {
                    vm.monthAvailability.reset();
                }
            };

            vm.assistSelected = function() {
                vm.assist.role = $filter('filter')(vm.rolesList, {store_id: vm.store.id, user_id: vm.assist.id},true)[0];
                if (!vm.isOver) {
                    vm.monthAvailability.reset();
                }
            };

            vm.commercialSelected = function() {
                vm.commercial.role = $filter('filter')(vm.rolesList, {store_id: vm.store.id, user_id: vm.commercial.id},true)[0];
                if (!vm.isOver) {
                    vm.monthAvailability.reset();
                }
            };

            vm.operatorFilter = function (role) {
              if (role.c_capability.man == 0) return;
              vm.operator.id = role.user_id;
              vm.operatorSelected();
              vm.monthAvailability.load();
            };


            // map
            var w = Math.max($document[0].documentElement.clientWidth, $window.innerWidth || 0);
            var isDraggable = w > 480 ? true : false;
            vm.map = {
              options:{
                  draggable: isDraggable,
                  scrollwheel: false,
                  disableDefaultUI: true
              },
              zoom: 14
            };
            // end map

            vm.openLightboxModal = function (index) {
                Lightbox.openModal(vm.store.gallery, index);
            };
            // end city stores


            // ---------- dateTime -------------------------------------//

            vm.dateTimeTitle = 'Scegli la <span>data</span> e l’<span>ora</span> *';

            // date
            // controllo se siamo oltre all'orario di chiusura
            vm.today = moment();
            vm.maxBirthDate = new Date();
            vm.maxBirthDate.setFullYear(vm.maxBirthDate.getFullYear() - 12);
            vm.nowTime = moment(vm.today.format('HH:mm'),'HH:mm');
            vm.closingTime = moment('20:00','HH:mm');
            if (vm.nowTime >= vm.closingTime){
                vm.dateStart = moment().add(1,'days');
            }else {
                vm.dateStart = moment();
            }
            vm.inlineOptions = {
                showWeeks: false,
                startingDay: 1,
                // minDate: moment(),
                customClass: function (data) {
                    if (data.mode != 'day') {
                        return "";
                    } else {
                        var std_date = moment(data.date).format("YYYY-MM-DD");
                        // var d = moment(data.date).format("DD");
                        var ym = moment(data.date).format("YYYY-MM");
                        var res = "";
                        if (!vm.monthAvailability.loaded[ym]) {
                            res = "";
                        } else {
                            if (vm.availabilitiesCount[std_date]!=null) {
                                var disp = null;
                                if (vm.dayMoment==null || vm.dayMoment=='') {
                                    disp = vm.availabilitiesCount[std_date].disp;
                                } else {
                                    disp = vm.availabilitiesCount[std_date]['disp_'+vm.monthAvailability.dayMomToLabel(vm.dayMoment)];
                                }
                                if (disp==0) {
                                    res = "";
                                } else {
                                    var dispInd = 1+Math.round(disp/100);
                                    if (dispInd>10) {
                                        dispInd = 10;
                                    }
                                    res = "availab-"+dispInd;
                                    var gp = vm.availabilitiesCount[std_date]['count_gp'];
                                    if (gp>0 && vm.isUser) {
                                        res += " count-gp-"+(1+Math.round(gp/3));
                                    }
                                }
                                // console.log(std_date + " availab: " + disp +
                                // " class: " + res);
                            }
                        }
                        return res;
                    }
                },
                dateDisabled:  function (data) {
                  var date = data.date,
                        mode = data.mode;
                    if (mode != 'day') return false;
                    var std_date = moment(data.date).format("YYYY-MM-DD");
                    var d = moment(data.date).format("DD");
                    var ym = moment(data.date).format("YYYY-MM");
                    var curr_ym = moment().format("YYYY-MM");
                    var toLoad = (d=='15');
                    if (toLoad) {
                        var load_date = null;
                        if (ym==curr_ym) {
                            load_date = moment().format("YYYY-MM-DD");
                        } else {
                            load_date = ym + "-01";
                        }
                        vm.monthAvailability.toLoadDate = load_date;
                        vm.monthAvailability.setToLoadYm(ym);
                    }
                    var res = true;
                    if (vm.monthAvailability.loaded[ym] && vm.monthAvailability.existsFull(std_date,vm.dayMoment)) {
                        res = false;
                    }

                    /**
                     * By passo calcoli vari
                     */
                  var oggi = moment().format("YYYY-MM-DD");
                  if (std_date>=oggi) {
                    return false;
                  } else {
                    return true;
                  }

                    return res;
                }
            };

            // day moments
            vm.dayMoment = '';
            vm.dayMomentList = [
                { value:'', label: '', description:'Tutti', icon: '', active: true, disabled:false, start: '08:00:00', end: '21:00:00', type:'euro' },
                { value:'0-720', minute_start:0, minute_end:720, label: '', description:'Mattina', icon: '', active: false, disabled:false, start: '08:00:00', end: '12:00:00', type:'euro' },
                { value:'720-870', minute_start:720, minute_end:870, label: '', description:'Pausa Pranzo', icon: '', active: false, disabled:false, start: '12:00:00', end: '14:30:00', type:'euro' },
                { value:'870-1020', minute_start:870, minute_end:1020, label: '', description:'Pomeriggio', icon: '', active: false, disabled:false, start: '14:30:00', end: '17:00:00', type:'euro' },
                { value:'1020-1440', minute_start:1020, minute_end:1440, label: '', description:'Sera', icon: '', active: false, disabled:false, start: '17:00:00', end: '21:00:00', type:'euro' }
            ];

            vm.reserved = undefined;
            vm.reservedOptionsList = [
              { value:undefined, label: '', description:'Tutti', icon: '', active: true, disabled:false, start: '', end: '', type:'' },
              { value: -1, label: '', description:'Riservati', icon: '', active: false, disabled:false, start: '', end: '', type:'' },
              { value: 0, label: '', description:'Non riservati', icon: '', active: false, disabled:false, start: '', end: '', type:'' }
            ];

            vm.reservedSelected = function() {
              vm.setAvailabilitiesToShowList();
            };
            // end day moment

            // NO MOMENTI GIORNATA

            vm.setAvailabilitiesToShowList = function () {
              /**
                 * devo tener conto anche del fatto se è prima volta: faccio
                 * vedere solo il commerciale migliore?
                 */
              var tmpList = $filter('distributeAvailabilitiesInMomentsFilter')(vm.availabilitiesList,vm.dayMoment,vm.dayMomentList, vm.customer);
              if (vm.reserved == undefined) {
                // se sono storeuser non vedo commerciali altrimenti non vedo
                // store
                var tmpArr = $filter('filter')(tmpList, { reserved: 0 }, true);// non riservati + store se presenti
                tmpArr = tmpArr.concat($filter('filter')(tmpList, { reserved: 5 }, true));

                if (vm.treatment && vm.treatment.f_meet) {
                    tmpArr = tmpArr.concat($filter('filter')(tmpList, { reserved: 8 }, true));
                }

                if (vm.user!=null) {
                  var other = 1;
                  if (vm.isStoreUser) {
                      other = 2;
                  }
                  vm.availabilitiesToShowList = tmpArr.concat($filter('filter')(tmpList, { reserved: other }, true));
                } else {
                  vm.availabilitiesToShowList = tmpArr;
                }
                // devo ordinarlo
                // $log.info(vm.availabilitiesToShowList);
                vm.availabilitiesToShowList = $filter('orderBy')(vm.availabilitiesToShowList, 'date_start');
                // $log.info(vm.availabilitiesToShowList);
              } else {
                vm.availabilitiesToShowList = $filter('filter')(tmpList, {reserved: vm.reserved},true);
              }
                vm.availability = null;
              if (vm.availabilitiesToShowList.length>0) {
                var curDate = moment(vm.date).format('YYYY-MM-DD');
                $log.info("curDate is: "+curDate);
                for(var i=0; i<vm.availabilitiesToShowList.length; i++) {
                    var el = vm.availabilitiesToShowList[i];
                    if (el.date == curDate) {
                        // $log.info("OK: "+el.date);
                        vm.availability = el;
                        // $log.info(el);
                        break;
                    }
                }
                  // default devo mettere il primo orario disponibile della data
                // selezionata
              }
            };


            // all'avvio e al cambio del momento del giorno, ricalcolo le
            // disponibilità da mostrare
            // NO MOMENTI GIORNATA
            /*
             * $scope.$watch('booking.dayMoment', function() {
             * vm.setAvailabilitiesToShowList(); },true);
             */


            vm.gp = 0;
            vm.date4Labels = null;
            vm.dateSelected = function() {
                vm.search();
            };

            vm.momentSelected = function() {
                /**
                 * devo far aggiornare il calendario con la disponibilità per
                 * questo daymoment
                 */
                /*
                 * if (vm.date!=null &&
                 * vm.monthAvailability.exists(moment(vm.date).format("YYYY-MM"),
                 * vm.dayMoment)) { vm.date =
                 * moment(vm.monthAvailability.getFirst(moment(vm.date).format("YYYY-MM"),
                 * vm.dayMoment)); } else {
                 */
                vm.date = moment(vm.date);// imposto la data corrente per il
                                            // ricalcolo delle disponibilità
                vm.dateStr = moment(vm.date).format('YYYY-MM-DD');
                /**
                 * Aggiorno la lista con i soli momenti disponibili nel
                 * dayMoment selezionato
                 */
                // }
                vm.setAvailabilitiesToShowList();
            };

            vm.loading = false;
            vm.searchLoading = false;
            vm.availabilitiesList = [];
            vm.availabilitiesCount = [];
            vm.appointmentsToShowList = [];
            vm.getOptionsForAvailability = function() {
                var date_start = vm.dateStart.format('YYYY-MM-DD')+' 08:00:00';
                if(vm.date!=null){
                    date_start = moment(vm.date).format('YYYY-MM-DD')+' 08:00:00';
                }
                var options = {date_start:date_start,treatment_id:vm.treatmentId,store_id:vm.storeId, user_times: vm.user_times};

                // caso della centralinista alla quale servono tutte le
                // disponibilità
                // Modificato per tutte le operatrici
                if( vm.operatorId != null ) {
                    options.all = true;
                };
                if (vm.operator.id != null && vm.operator.id!='') {
                    options.user_id = vm.operator.id;
                }
                if (vm.assist.id != null && vm.assist.id!='') {
                    options.assist_user_id = vm.assist.id;
                }
                /*
                 * if (vm.dayMoment!=null && vm.dayMoment!='') { options.minutes =
                 * vm.dayMoment; }
                 */
                options.c_role = vm.userRole;
                if (!vm.kpiCheck) {
                    options.kpi_check = false;
                }
                return options;
            }
            vm.monthAvailability = {
                    loading: false,
                    loaded: [],
                    isLoaded: false,
                    data: null,
                    toLoadDate: null,
                    toLoadYm: null,
                    isCurrentYmLoaded: false,
                    setToLoadYm: function (ym) {
                        this.toLoadYm = ym;
                        var res = this.toLoadYm!=null && this.loaded[this.toLoadYm]!=null && this.loaded[this.toLoadYm].val;
                        this.isCurrentYmLoaded = res;
                        if (!this.isCurrentYmLoaded && !vm.user && vm.landing && vm.treatment) {
                            this.load();
                        }
                        /*
                         * if (vm.monthAvailability.loaded[ym]!=null) { if
                         * (vm.monthAvailability.loaded[ym].found &&
                         * !vm.searchLoading) { vm.date =
                         * moment(vm.monthAvailability.loaded[ym].firstDay);
                         * vm.search(); } else if
                         * (!vm.monthAvailability.loaded[ym].found) { vm.date =
                         * null; vm.availability = null; vm.availabilitiesList =
                         * []; vm.availabilitiesToShowList = []; } }
                         */
                        // console.log("isCurrentYmLoaded " +ym +" ->
                        // "+this.isCurrentYmLoaded);
                    },
                    load: function () {
                        var data = this.toLoadDate;
                        this.data = data;
                        this.loading = true;
                        vm.loading = true;
                        var options = vm.getOptionsForAvailability();
                        var firstDay = data + " 08:00:00";
                        options.date_start = firstDay;
                        var lastDay = moment(firstDay).add(1, 'months').date(0).format('YYYY-MM-DD')+' 23:59:59';
                        options.date_to = lastDay;
                        // console.log(options);
                        MyAvailabilityService.availabilitiesCount(options, vm.currentAPI).then(
                            function(response) {
                                var found=false;
                                var firstDay = "";
                                if (response.data!=null && response.data.length>0) {
                                    for(var i=0;i<response.data.length; i++) {
                                        if (!found) {
                                            found=true;
                                            firstDay = response.data[i].date + " 08:00:00";
                                        }
                                        vm.availabilitiesCount[response.data[i].date] = response.data[i];
                                    }
                                }
                                vm.monthAvailability.loading=false;
                                vm.monthAvailability.loaded[data.substring(0,7)]={val: true, found: found, firstDay: firstDay};
                                vm.monthAvailability.isCurrentYmLoaded = true;
                                vm.monthAvailability.isLoaded = true;
                                vm.loading = vm.searchLoading;
                                if (found) {
                                    vm.date = moment(firstDay);
                                    vm.dateStr = vm.date.format('YY-MM-DD');
                                    vm.search();
                                } else {
                                    /*
                                     * vm.date = null; vm.availability = null;
                                     * vm.availabilitiesList = [];
                                     * vm.availabilitiesToShowList = [];
                                     */
                                }
                                if (!vm.isUser) {
                                    ga('set', 'page', '/appointments-available-count');
                                    ga('send', 'pageview');
                                    //$http.post(vm.env.API+"/handleerror",{params: response})
                                }
                            },
                            function (response) {
                                 var msg = vm.getErrorMsg(response);
                                 vm.monthAvailability.loading=false;
                                 vm.loading = vm.searchLoading;
                                 if (!vm.isUser) {
                                    ga('set', 'page', '/appointments-available-count/error');
                                    ga('send', 'pageview');
                                    $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: response})
                                        .then(
                                            function() {},
                                            function() {}
                                    );
                                 }
                                 alert ( "C'è stato un problema nel caricamento della disponibilità." + (msg!=null?" " +msg:""));
                            }
                        );
                    },
                    reset: function () {
                        vm.date = null;
                        vm.dateStr = null;
                        vm.availabilitiesCount = [];
                        vm.monthAvailability.loaded = [];
                        vm.monthAvailability.isLoaded = false;
                        vm.availability = null;
                        vm.availabilitiesList = [];
                        vm.availabilitiesToShowList = [];
                        vm.appointmentsToShowList = [];
                        vm.event2Show = {};
                        vm.isOver = false;
                        vm.monthAvailability.isCurrentYmLoaded = false;
                        // faccio rieseguire il load del calendario
                        /*
                         * if (vm.date!=null) { vm.date = moment(vm.date); }
                         * else { //vm.date = moment();//imposto la data
                         * corrente }
                         */
                    },
                    getFirst: function(date_ym, dayMoment) {
                        var day = moment(date_ym+"-01");
                        while (day.format("YYYY-MM")==date_ym) {
                            var k = day.format("YYYY-MM-DD");
                            if (vm.availabilitiesCount[k]!=null && vm.availabilitiesCount[k]['disp_'+this.dayMomToLabel(dayMoment)]>0) {
                                return k;
                            }
                            day = day.add(1,'days');
                        }
                        return null;
                    },
                    exists: function (date_ym,dayMoment) {
                        return this.getFirst(date_ym, dayMoment)!=null;
                    },
                    getCounts: function (k) {
                        return vm.availabilitiesCount[k];
                    },
                    existsFull: function (k,dayMoment) {
                        var el = this.getCounts(k);
                        if (dayMoment==null || dayMoment=='') {
                            return el!=null && el.disp>0;
                        } else {
                            return el!=null && el['disp_'+this.dayMomToLabel(dayMoment)]>0;
                        }
                    },
                    dayMomToLabel: function(dm) {
                        var DM_MAP = [];
                        DM_MAP['0-720'] = "morning";
                        DM_MAP['720-870'] = 'lanch';
                        DM_MAP['870-1020'] = 'afternoon';
                        DM_MAP['1020-1440'] = 'dinner';
                        return DM_MAP[dm];
                    }
            }
            /**
             * Cambio data clic su calendario e carico disponibilità del giorno
             */
            vm.search = function() {
              vm.event2Show = {};
              vm.availabilitiesList = [];
              vm.appointmentsToShowList = [];
              vm.availabilitiesToShowList = [];
              vm.availability = null;
              if (vm.monthAvailability.loading) {
                  // alert("Il caricamento disponibilità non è terminato
                    // correttamente, attendere o riprovare.");
                  return;
                }
              if (vm.date == null) {
                // alert("Il caricamento disponibilità non è terminato
                // correttamente, o la data non è stata impostata, attendere o
                // riprovare.");
                return;
              }
              vm.loading = true;
                vm.searchLoading = true;
                var options = vm.getOptionsForAvailability();
                vm.date_frmt = moment(vm.date).format('dddd, D MMMM');
                var ym = moment(vm.date).format('YYYY-MM-DD');
                var el = vm.monthAvailability.getCounts(ym);
                if (el!=null) {
                    vm.gp = el.count_gp;
                } else {
                    vm.gp = 0;
                }
                if (vm.isUser) {
                    vm.loadAppointments();
                    vm.loadEvent2Show();
                }
                MyAvailabilityService.availabilities(options, vm.currentAPI).then(
                  function(response) {
                    vm.date1 = null;
                  vm.date2 = null;
                  vm.date3 = null;

                    var date1, date2, date3;
                    date1 = moment(vm.date);
                  date2 = moment(vm.date).add(1,'days');
                  date3 = moment(vm.date).add(2,'days');

                    var frmt = 'dddd, D MMMM';
                    if (response.data && response.data.data) {
                         vm.date1 = response.data.meta[0];
                        vm.date2 = response.data.meta[1];
                        vm.date3 = response.data.meta[2];

                          angular.forEach(response.data.data, function (el) {
                          el.customer_id = null;
                          if (el.date_start==null && el.hours!=null) {
                              el.store_id = options.store_id;
                            el.treatment_id = vm.treatment.id;
                            el.price = vm.treatment.start_price;
                            el.date_start = el.date + ' ' + el.hours;
                            el.date_end = moment(el.date_start).add(vm.treatment.duration, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                            // delete el.date;
                            el.minute;
                            delete el.hours;
                          }

                          el.role = {data: {c_capability: {comm: 1}} };
                          el.user = {data: {} };

                          angular.forEach(vm.rolesList, function (r) {
                            if (r.user_id == el.user_id) {
                              el.role = {data: r};
                              el.user = {data: r.user};
                            }
                            if (r.user_id == el.assist_user_id) {
                                el.assistRole = {data: r};
                                el.assistUser = {data: r.user};
                            }
                            if (r.user_id == el.commercial_user_id) {
                                el.commercialRole = {data: r};
                                el.commercialUser = {data: r.user};
                            }
                          });
                          // $log.info(el);
                        vm.availabilitiesList.push(el);
                        });
                        //$log.info(vm.availabilitiesList);
                  if (vm.availabilitiesList.length>0) {
                      vm.setAvailabilitiesToShowList();
                  }
                  vm.loading = vm.monthAvailability.loading;
                  vm.searchLoading = false;
                  // per far visualizzare la data formattata
                  // NO MOMENTI GIORNATA
                  /*
                     * vm.dayMomentsList_before =
                     * $filter('setDayMomentsFilter')(vm.availabilitiesList,vm.defaultDayMoments);
                     * vm.dayMoment =
                     * $filter('setFirstMomentFilter')(vm.dayMomentsList_before);
                     * vm.dayMomentsList =
                     * $filter('setActiveRadioButtonFilter')(vm.dayMoment,vm.dayMomentsList_before);
                     * //setto ad active il primo momento
                     */
                 }
                 vm.date1_frmt = moment(vm.date1).format(frmt);
                 vm.date2_frmt = moment(vm.date2).format(frmt);
                 vm.date3_frmt = moment(vm.date3).format(frmt);

                  if (!vm.isUser) {
                      ga('set', 'page', '/appointments-available');
                      ga('send', 'pageview');
                  }
              },
              function(data) {
                  var msg = vm.getErrorMsg(data);
                  alert ( "C'è stato un problema nel caricamento della disponibilità per il giorno selezionato." + (msg!=null?" " +msg:""));
                  vm.loading = vm.monthAvailability.loading;
                  vm.searchLoading = false;
                  if (!vm.isUser) {
                        ga('set', 'page', '/appointments-available/error');
                        ga('send', 'pageview');
                        $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                            .then(
                                function() {},
                                function() {}
                        );
                  }
               }
                 );
            };

            /**
             * Carico gli appuntamenti già presi per la data selezionata
             */

            vm.appointmentsToShowList = [];
            vm.loadAppointments = function() {
                vm.appointmentsToShowList = [];
                var options = {
                    with : 'role;treatment',
                    search :
                        'recalled:3' +
                        ';date_start:' + moment( vm.date ).format( 'YYYY-MM-DD' ) +
                        ';date_end:' + moment( vm.date ).add( 1, 'days' ).format( 'YYYY-MM-DD' ) +
                        ';store_id:' + vm.storeId
                    ,
                    searchFields : 'date_start:>;date_end:<;store_id:=;recalled:<',
                    orderBy: 'date_start',
                    sortedBy: 'asc',
                    s: 100 // per bypassare la paginazione
                };
                AppointmentService
                    .all( options, vm.currentAPI )
                    .then(
                            function (data) {
                                vm.appointmentsToShowList = data;
                                // console.log(vm.appointmentsToShowList);
                            },
                            function (data) {
                                $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                                    .then(
                                        function() {},
                                        function() {}
                                );
                            }
                    )
                    // .finally( vm.reRenderEvents )
                ;
            };

            vm.loadEvent2Show = function() {
                vm.event2Show = {};
                var path = "booking";
                var date = moment( vm.date ).format( 'YYYY-MM-DD' );
                $http.get(vm.currentAPI+"/events/2show/"+vm.storeId+"/"+date+"/"+path).then(
                        function (response) {
                            if (response.data.data) {
                                vm.event2Show = response.data.data;
                            }
                        }
                )
            };

            vm.insertPf = function() {
                //alert('/pf?cph='+vm.customer.phone);
                window.location = ('/pf?cph='+vm.customer.phone + '&token='+vm.token);
            }

            vm.getErrorMsg = function (response) {
                if (!vm.isUser) return null;
                var msg = null;
                if (response.data!=null && response.data.message!=null) {
                    msg = response.data!=null && response.data.message!=null?"\n\nERRORE: "+ response.data.message:"";
                    msg += response.config!=null && response.config.url!=null?"\nURL: "+response.config.url:"";
                    if (vm.user && (vm.user.id == 20 || vm.user.type=='admin')) {
                        if (response.data!=null && response.data.debug!=null) {
                            msg += "\n\nCLASS: "+response.data.debug.class;
                            msg += "\nTRACE:";
                            for(var i=0;i<response.data.debug.trace.length && i<5;i++) {
                                msg += "\n"+response.data.debug.trace[i];
                            }
                        }
                    }
                }
                return msg;
            };

            // ---------- customerdata -------------------------------------//

            vm.customerChecking = false;
            vm.customerLoaded = false;
            vm.user_times = vm.isCallCenter ? 0:2;
            vm.user_times_descr = (vm.user_times<1) ? 'Primo ingresso': 'Smaltimento';
            // alert(vm.user_times);
            // alert(vm.isCallCenter);

            vm.haveAppointmensPaid = function(days) {
                if (!vm.customer || !vm.customer.appointments ||
                    !vm.customer.appointments.data) {
                    return false;
                }
                for(var i=0; i<vm.customer.appointments.data.length; i++) {
                    var app = vm.customer.appointments.data[i];
                    if (app.paid) {
                        //console.log('adesso');
                        //console.log(moment().format('YYYY-MM-DD HH:mm'));
                        //console.log('date_start');
                        //console.log(app.date_start);
                        if(app.date_start<moment().format('YYYY-MM-DD HH:mm')) {
                            //console.log('start + 120 < now')
                            //console.log(moment(app.date_start).add(days,'days').isAfter(moment()));
                            return moment(app.date_start).add(days,'days').isAfter(moment());
                        }
                    }
                };
                return false;
            };
            vm.haveFutureAppointmens = function() {
                if (!vm.customer || !vm.customer.appointments ||
                    !vm.customer.appointments.data) {
                    return false;
                }
                for(var i=0; i<vm.customer.appointments.data.length; i++) {
                    var app = vm.customer.appointments.data[i];
                    if (app.recalled<3) {
                        if(app.date_start>=moment().format('YYYY-MM-DD HH:mm')) {
                            return app;
                        }
                    }
                };
                return false;
            }
            vm.haveSubscriptionActive = function() {
                if (!vm.customer ||
                    !vm.customer.customer_subscriptions ||
                    !vm.customer.customer_subscriptions.data) {
                    return false;
                }
                for(var i=0; i<vm.customer.customer_subscriptions.data.length; i++) {
                    var s = vm.customer.customer_subscriptions.data[i];
                    if (!s.f_over && s.app_remaining>0) {
                        //console.log('trovato abbonamento attivo');
                        return true;
                    }
                };
                return false;
            };

            vm.existLeadComm = false;
            vm.existLeadRef = false;
            vm.checkLeadExist = function() {
                if (vm.customer && vm.customer.leads && vm.customer.leads.data
                        && vm.customer.leads.data.length>0) {
                    angular.forEach(vm.customer.leads.data, function(l) {
                        if (!l.f_dup &&
                            !l.f_oper &&
                            (!vm.user || l.user_id != vm.user.id) &&
                            !['rullo','conferma','non presentato','non fidelizzato','confermaop','confermacomm','disdetto','phonefriend']
                                .includes(l.category)
                            && !['ha preso appuntamento', 'ha già preso appuntamento']
                                .includes(l.call_state)
                            && moment(l.created_at.date?l.created_at.date:l.created_at).add(3,'months').format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
                                vm.existLeadComm = l;
                            }
                        if (l.categoria == 'REF' && l.category == 'phonefriend') {
                            vm.existLeadRef = l;
                        }
                    });
                }
            };

            vm.buildCustomerAppointments = function() {
                if (vm.treatmentsLoaded && vm.customer && vm.customer.appointments && vm.customer.appointments.data) {
                    angular.forEach(vm.customer.appointments.data,function(app) {
                        app.treatment = {'data': $filter('getTreatmentFilter')(vm.treatmentsListAll,app.treatment_id,true)};
                        angular.forEach(vm.storesList, function(store) {
                            if (app.store_id == store.id) {
                                app.store = {'data': store};
                            }
                        });
                        /**
                         * devo impostare il role e l'appuntamento
                         */
                        var appRole = $filter('filter')(vm.rolesList,{user_id: app.user_id, store_id: app.store_id},true);
                        if (appRole && appRole.length>0) {
                            app.role = {'data': appRole[0]};
                        }
                        app.date_start_frmt = moment(app.date_start).format("DD/MM/YYYY HH:mm");
                        var createdAt = moment((app.created_at && app.created_at.date)?app.created_at.date:app.created_at);
                        //console.log(app.created_at);
                        //console.log(createdAt);
                        //console.log(vm.nearestBirthdate().subtract(15,'day'));
                        //console.log("->"+(vm.nearestBirthdate().subtract(15,'day')<createdAt));
                        if (vm.birthdate
                            && app.treatment.data.f_birthday
                            && app.recalled<3
                            && vm.nearestBirthdate().subtract(15,'days').isBefore(createdAt)) {
                            $state.go('booking-promo-already');
                        } else if (vm.birthdate && app.treatment.data.f_birthday){
                            //console.log('non considero questo app:');
                            //console.log(app);
                        }
                    });
                }
            };

            // Caso in cui il cliente prenota compleanno o landing personalizzata
            if( vm.customerId && !vm.isUser && (vm.birthdate || vm.landing)) {
                vm.customer.phone = vm.customerId;
                vm.checkCustomer();
            }

            /*
             * $scope.$watch( 'booking.treatment.start_price', function( value ) {
             * if( angular.isDefined( value ) ) { if( vm.landing ) {
             * vm.priceOverride = vm.landing.price; vm.treatment.start_price =
             * vm.landing.price; } else { if(vm.priceFromSubscription ===
             * false){ vm.priceOverride = value; } } } } );
             */

            /*
             * $scope.$watch( 'booking.search_treatment', function( value ) {
             * //vm.treatmentId = null; //vm.treatment = null; $log.info ("watch
             * search_treatment vm.search_treatment : " + vm.search_treatment); } );
             */

            vm.customerSubscriptionIdChange = function() {
                var value = vm.customer_subscription_id;
                $log.info("customerSubscriptionIdChange: "+vm.customer_subscription_id)
                if(value) {
                    vm.subscription_new_id = null;
                    vm.priceOverride = 0;
                    vm.priceFromSubscription = true;
                } else {
                    vm.priceFromSubscription = false;
                    vm.priceOverride = vm.getTreatmentPrice();
                }
                return vm.priceOverride;
            };

            vm.subscriptionNewIdChange = function () {
                var value = vm.subscription_new_id;
                if (value) {
                    vm.customer_subscription_id = null;
                    vm.priceOverride = 0;
                    vm.priceFromSubscription = false;
                    angular.forEach( vm.subscriptionsList, function( elem ) {
                        if(elem.id == value) {
                            vm.priceOverride = elem.price;
                            vm.priceFromSubscription = true;
                        }
                    });
                } else {
                    vm.priceFromSubscription = false;
                    vm.priceOverride = vm.getTreatmentPrice();
                }
                return vm.priceOverride;
            }

            vm.appHaveOverlap = function(app) {
                var res = false;
                var start, end, valid;

                if (!vm.isOver) {
                    valid = vm.availability;
                    if (valid) {
                        end = vm.availability.date_end
                        start = vm.availability.date_start;
                    }
                } else {
                    valid = vm.overDateStart;
                    // $log.info(vm.overDateStart);
                    if (valid) {
                        start = moment(vm.date).format('YYYY-MM-DD') + " " + moment(vm.overDateStart).format("HH:mm");
                        end = moment(start).add(vm.treatment.duration, 'minutes').format("YYYY-MM-DD HH:mm");
                    }
                }
                // $log.info("Check overlap: start->" + start + " end->"+end);
                res = valid && app.date_start<end && app.date_end>start;
                /*
                 * if (res) { $log.info("Found overlap"); $log.info(app); }
                 */
                return res;
            };
            /*
             * $scope.$watch('booking.date', function(newValue, oldValue) {
             * //var vm = $scope.booking; //console.log($scope);
             * //console.log($scope.booking); //$log.info("I've changed -> new: " +
             * moment(newValue).format("YYYY-MM-DD HH:mm") + " old:" +
             * moment(oldValue).format("YYYY-MM-DD HH:mm")); });
             */

            /*
             * $scope.$watch('booking.availability', function(newValue,
             * oldValue) { //console.log($scope); //console.log($scope.booking);
             * $log.info(newValue); $log.info(oldValue); });
             */

            /*
             * $scope.$watch('booking.isClient', function() { if(vm.isClient) {
             * //vm.customerDataTitle = 'Lascia i tuoi dati per usufruire di
             * <span>sconti e promozioni</span>'; if(isUser || vm.user){
             * vm.customerDataTitle = 'Dati di <span>'+vm.customer.firstname+'</span>'; }
             * }else{ vm.customerDataTitle = 'Lascia i tuoi <span>dati</span>';
             * if(isUser || vm.user){ vm.customerDataTitle = 'Inserisci i dati
             * del <span>cliente</span>'; } } },true);
             */


            // ---------- SEND DATA -------------------------------------//

            vm.initAvailabilityOver = function () {
                var availab = {
                        store_id: vm.storeId,
                        treatment_id: vm.treatmentId,
                        price: vm.treatment.start_price,
                        user_id: vm.operator.id,
                        assist_user_id: vm.assist.id,
                        commercial_user_id: vm.commercial.id
                };
                var date_start = moment(vm.date).format('YYYY-MM-DD') + " " + moment(vm.overDateStart).format("HH:mm");
                var date_end = moment(date_start).add(vm.treatment.duration, 'minutes').format("YYYY-MM-DD HH:mm");
                availab.date_start = date_start;
                availab.date_end = date_end;
                availab.f_over = 1;
                return availab;
            };


            vm.appointmentSave = function() {
                AppointmentService.save(vm.availability, vm.currentAPI).then(function(){
                    // per la pagina conferma prenotazione
                      vm.isSaving = false;
                    if(vm.isUser){
                      if (vm.appointmentId!=null) {
                          ngDialog.open({
                              template: '<div class="message-dialog">Spostamento effettuato.</div>',
                              plain: true
                          });
                          vm.appointmentId = null;
                          vm.leadId = null;
                          vm.cantChangeCustomer = false;
                          vm.customer = null;
                          if (!vm.env.apis) {
                              vm.removeLocalStorage();
                              window.history.go(-1); // torna
                                                      // all'amministrazione
                          } else {
                              window.close();
                          }
                      } else {
                          ngDialog.open({
                              template: '<div class="message-dialog">Prenotazione effettuata.</div>',
                              plain: true
                          });
                      }
                      vm.monthAvailability.reset();
                    } else{
                      $rootScope.appointment = vm.availability;
                      /**
                        * Traccia la presa app su analytics
                      */
                      ga('set', 'page', '/online-booking-completed');
                      ga('send', 'pageview');
                      $state.go('booking-completed');
                    }
                }, function errorCallback(data) {
                    if (!vm.isUser) {
                      $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                          .then(
                              function() {},
                              function() {}
                      );
                    }
                    vm.isSaving = false;
                    var message = 'Errore durante la prenotazione.<br/>Riprovare o contattare direttamente il centro.';
                    if(data.data.message == "appointment no longer available"){
                            message = "<h4><strong>Non è stato possibile prenotare l'appuntamento</strong> dalle ore "+moment(vm.availability.date_start).format('LT')+" alle ore "+moment(vm.availability.date_end).format('LT')+" in quanto appena prenotato da un altro operatore</h4><br/><strong>Riprovare con un altro orario o centro</strong>.<br> Grazie.";
                    } else if (vm.isUser && data.data.message) {
                        message += "<br/>"+data.data.message+".";
                    }
                    ngDialog.open({
                        template: '<div class="message-dialog">'+message+'</div>',
                        plain: true
                    });
                });
            };

            vm.isSaving = false;
            vm.isOver = false;
            vm.sendData = function () {
                $log.info('save');
                vm.isSaving = true;
                vm.customer_updated = {};
                if (vm.isOver) {
                    vm.availability = vm.initAvailabilityOver();
                }
                vm.availability.by_operator = 0;
                vm.availability.c_role = 'guest';
                if(vm.isUser){
                    vm.availability.confirmed = 1;
                    vm.availability.by_operator = vm.operatorId;
                    vm.availability.cus_act_id = vm.cusActId;
                    vm.availability.c_role = vm.userRole;
                    vm.availability.type_app = vm.typeApp;
                };
                vm.availability.cus_phone = vm.customer.phone;
                vm.customer.gender = vm.gender;
                vm.availability.note = vm.note;
                vm.availability.paid = null;

                if (vm.source) {
                    vm.availability.source = vm.source;
                }
                if (vm.couponCode) {
                    vm.availability.coupon_code = vm.couponCode;
                }
                if (vm.appCustomerId) {
                    vm.availability.app_customer_id = vm.appCustomerId;
                }

                Object.keys(vm.utms).forEach(function(key) {
                    if (vm.utmsValues[key]) {
                        vm.availability[vm.utms[key]] = vm.utmsValues[key];
                    }
                });

                if (vm.wkFlow) {
                    if (!vm.referral || vm.referralCan) {
                        vm.availability.wkFlow = vm.wkFlow;
                        vm.availability.wkStateTo = vm.wkStateTo;
                        vm.availability.wkStateFrom = vm.wkStateFrom;
                        vm.availability.wkEntityId = vm.wkEntityId;
                        if (!vm.customer.id && vm.wkFlow == 'REF') {
                            vm.customer.source = 'Referral';
                        }
                    }
                } else if (vm.customer.src_phone) {
                    /**
                     * Progetto referral
                     */
                    if (vm.referralCan) {
                        vm.availability.wkFlow = 'REF';
                        vm.customer.source = 'Referral';
                        if (vm.treatment.name == 'Consulenza Telefonica') {
                            vm.availability.wkStateTo = 'BookPhone';
                        } else {
                            vm.availability.wkStateTo = 'Book';
                        }
                    }
                } else {
                    vm.availability.wkFlow = null;
                    vm.availability.wkStateTo = null;
                }

                /**
                 * Utente nuovo
                 */
                if( vm.customer.id==null ) {
                    CustomerService.save(vm.customer, vm.currentAPI).then(function(data) {
                        data.birthdate = data.birthdate ? new Date(data.birthdate) : null;
                        vm.customer = data;
                        vm.customer.f_notyfy_wa = vm.customer.f_notyfy_wa || (!vm.customer.f_notyfy_email && !vm.customer.f_notyfy_sms) ? 1 : 0;
                        vm.customer.f_notyfy_sms = vm.customer.f_notyfy_sms ? 1 : 0;
                        vm.customer.f_notyfy_email = vm.customer.f_notyfy_email ? 1 : 0;
                        vm.availability.new_customer = 1;
                        vm.availability.customer = vm.customer;
                        vm.availability.customer_id = vm.customer.id;
                        if(vm.treatmentPrice){
                            vm.availability.price = vm.treatmentPrice;
                        }
                        if(( vm.priceOverride && vm.isCallCenter ) || ( vm.priceOverride && vm.priceFromSubscription === true)){
                          vm.availability.price = vm.priceOverride;
                        }
                        vm.appointmentSave();
                    }, function ( data ) {
                        if (!vm.isUser) {
                            $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                                .then(
                                    function() {},
                                    function() {}
                            );
                        }
                        vm.isSaving = false;
                        var message = 'Errore durante la prenotazione.<br/>Riprovare o contattare direttamente il centro.<br/>';
                        message += '<strong>Non è stato possibile inserire il nuovo utente!</strong></br>';
                        if( vm.isUser && data.data.message) {
                            message += "<br/>"+data.data.message;
                        }
                        ngDialog.open({
                            template: '<div class="message-dialog">'+message+'</div>',
                            plain: true
                        });
                    });
                } else {
                    /*
                     * Duplicato l'utente per non ricevere errori JS dalle date
                     * di Angular
                     */
                    // if(vm.appointmentId==null) {

                    if((vm.customer_subscription_id !== undefined) && (vm.customer_subscription_id !== '')) {
                        vm.availability.type = 'abb';
                        vm.availability.customer_subscription_id = parseInt(vm.customer_subscription_id);
                    }

                    if((vm.subscription_new_id !== undefined) && (vm.subscription_new_id !== '')) {
                        vm.availability.type = 'abb';
                        vm.availability.subscription_new_id = parseInt(vm.subscription_new_id);
                    }

                    angular.copy( vm.customer, vm.customer_updated );

                    vm.customer_updated.birthdate = vm.customer.birthdate ? moment( vm.customer.birthdate ).format( 'YYYY-MM-DD' ) : null;
                    vm.customer_updated.birthdate2 = vm.customer.birthdate ? moment( vm.customer.birthdate ).format( 'YYYY-MM-DD' ) : null;
                    console.log("birthdate: "+vm.customer_updated.birthdate);
                    console.log("birthdate2: "+vm.customer_updated.birthdate2);
                    
                    delete vm.customer_updated.appointments;
                    vm.availability.customer = vm.customer_updated;
                    /*
                        * Duplicato l'utente per non ricevere errori JS dalle
                        * date di Angular
                        */
                    /*
                        * prima era semplicemente vm.customer.birthdate =
                        * vm.customer.birthdate ? moment( vm.customer.birthdate
                        * ).format( 'YYYY-MM-DDT' ) : null;
                        */
                    vm.customer.birthdate = vm.customer.birthdate ? new Date( moment( vm.customer.birthdate ).format( 'YYYY-MM-DD' ) ) : null;
                    vm.availability.customer_id = vm.customer.id;

                    if(vm.treatmentPrice) {
                        vm.availability.price = vm.treatmentPrice;
                    }

                    if(( vm.priceOverride >= 0 && vm.isCallCenter ) || ( vm.priceOverride >= 0 && vm.priceFromSubscription === true)){
                        vm.availability.price = vm.priceOverride;
                    }

                    vm.availability.moveFromAppId = vm.appointmentId;
                    if (vm.leadId!=null) {
                        vm.availability.lead_id = vm.leadId;
                    }

                    // aggiorno i dati cliente (solo se sono autenticato) oppure se non presente referral e ho referral
                    if (vm.isUser || vm.referral
                        && (!vm.customer.src_cid || moment(vm.customer.src_cid_at).isBefore(moment().subtract(1,'years')))
                    ) {
                        vm.availability.src_phone = vm.customer.src_phone;
                        vm.customer_updated.put().then(
                            function(data) {
                                vm.appointmentSave();
                            },
                            function(data) {
                                if (!vm.isUser) {
                                    $http.post((vm.env.currentAPI?vm.env.currentAPI:vm.env.API)+"/handleerror",{params: data})
                                        .then(
                                            function() {},
                                            function() {}
                                    );
                                }
                                vm.isSaving = false;
                                var message = 'Errore durante il salvataggio dei dati.';
                                if (vm.isUser && data.data.message) {
                                    message += "<br/>"+data.data.message;
                                }
                                ngDialog.open({
                                    template: '<div class="message-dialog">'+message+'</div>',
                                    plain: true
                                });
                            }
                        );    
                    } else {
                        vm.appointmentSave();
                    }
                }


            };

            // Check for User logged-in
            vm.redirectLogout = function() {
                $state.go('booking-notauthorized');
            };
            vm.removeLocalStorage = function() {
                localStorage.removeItem( 'Biolaser_token' );
                localStorage.removeItem( 'user' );
            };
            if (!token && !vm.env.apis && (!vm.env.anonymous_access===false)) {
                vm.removeLocalStorage();
            } else if ((vm.env.apis || vm.env.anonymous_access===false) && !token) {
                token = localStorage.getItem( 'Biolaser_token' );
            }
            vm.doLogin = function() {
                var data = {
                    email : vm.loginEmail,
                    password : vm.loginPassword,
                    version: vm.version
                };
                vm.loading = true;
                $auth.login( data ).then(
                    function(response) {
                        vm.token = response.data.token;
                        // alert (vm.token);
                        vm.initOperatorByToken(vm.token);
                        vm.loading = false;
                    },
                    function( error ) {
                        // $log.info( error );
                        var msg = "";
                        var wrongVersion = false;
                        if (error!=null && error.data!=null && error.data.error!=null) {
                          msg = "\n"+error.data.error;
                          wrongVersion = error.data.wrongVersion;
                        }
                        alert( "Autenticazione fallita." + msg);
                        vm.loading = false;
                        if (wrongVersion) {
                          $window.location.reload();
                        }
                        return;
                    }
                )
            };
            vm.initOperatorByToken = function(token) {
                vm.loading = true;
                localStorage.setItem( 'Biolaser_token', token );
                UserService
                    .logIn(token)
                    .then(
                        function( response ) {
                            if( response.data.user ) {
                                localStorage.setItem( 'user', angular.toJson( response.data.user ) );
                                /* Operatore connesso */
                                var user = angular.fromJson( localStorage.getItem( 'user' ) );
                                if( user ) {
                                    // vm.operator = user;
                                    vm.user = user;
                                    angular.forEach(vm.user.roles, function (r) {
                                      if (r.active && userRole == r.role && r.store_id == userSid) {
                                        vm.user.type = userRole;
                                        vm.user.color = r.color;
                                        vm.user.store_id = userSid;
                                      }
                                    });
                                    vm.reserved = undefined;
                                    if (userRole == 'operator' || userRole == 'storemngr') {
                                      vm.isStoreUser = true;
                                      vm.reservedOptionsList[1].value = 2;// posso
                                                                            // filtrare
                                                                            // sui
                                                                            // riservati
                                                                            // centro
                                    } else {
                                      vm.isStoreUser = false;
                                      vm.reservedOptionsList[1].value = 1;// posso
                                                                            // filtrare
                                                                            // sui
                                                                            // riservati
                                                                            // commerciale
                                    }
                                    vm.setUserAlias(user, user);
                                    vm.operatorId = user.id;
                                    vm.user_type = user.type;
                                    vm.isCallCenter = ( vm.user_type === 'callcenter' ||  vm.user_type === 'admin') ? true : false;
                                    /*if (!vm.env.apis) {
                                        vm.loadStores();
                                    }*/
                                    /**
                                     * Inizializzo promo
                                     */
                                    if (vm.user_type === 'callcenter' && vm.user.tag_area!='INBOUND') {
                                        vm.typeApp = 'promo';
                                    }
                                    /**
                                     * Inizializzo cliente se presente
                                     */
                                     if( vm.customerId && vm.isUser ){
                                        vm.customer.phone = vm.customerId;
                                        vm.checkCustomer();
                                    }
                                } else {
                                    vm.doLogout();
                                }
                            }
                            vm.loading = false;
                            vm.initialized = true;
                        },
                        vm.doLogout
                    )
                ;
            };
            vm.doLogout = function() {
                TokenService
                    .delete()
                    .finally( $auth.logout )
                    .finally( function() {
                        vm.removeLocalStorage();
                        vm.loading = false;
                        vm.initialized = true;
                        if (vm.isUser) {
                            vm.user = null;
                            if (!vm.env.apis && !vm.env.anonymous_access===false) {
                            return  vm.redirectLogout();
                            }
                        }
                    } )
                ;
            };
            vm.state = $state;
            if( vm.env.apis || vm.env.anonymous_access===false || $state.current.name === 'booking-operator' ) {
                if ( token ) {
                    vm.initOperatorByToken(token);
                } else {
                    vm.initialized = true;
                }
            } else {
                // vm.loadStores();
            }
        };

        function BookingNotAuthorizedController($rootScope, env, $log){
            var vm = this;
            vm.env = env;
            //console.log(env);
            $log.info('BookingNotAuthorizedController');
            ga('set', 'page', '/notauthorized');
            ga('send', 'pageview');
        };

        function BookingCompletedController($rootScope, env, $log){
            var vm = this;
            vm.appointment = $rootScope.appointment;
            vm.env = env;
            $log.info('BookingCompletedController');
            $log.info(env);
        };

})();

(function () {
    'use strict';

    angular
            .module('birthday', [])
            .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
                .state('birthday-completed', {
                    url: '/bd/completed',
                    templateUrl: 'app/birthday/completed.html',
                    controller: 'BirthdayCompletedController',
                    controllerAs: 'completed'
                })
                .state('birthday', {
                    url: '/bd?p&d',
                    templateUrl: 'app/birthday/birthday.html',
                    controller: 'BirthdayController',
                    controllerAs: 'booking',
                    resolve: {
                        phone: function ($stateParams) {
                            return $stateParams.p ? $stateParams.p : null;
                        },
                        birthdate: function ($stateParams) {
                            return $stateParams.d ? $stateParams.d : null;
                        }
                    },
                });
    }

})();


(function () {
    'use strict';
    angular
            .module('birthday')
            .controller('BirthdayController', BirthdayController);
    /** @ngInject */
    function BirthdayController(
            $state,
            $scope,
            $filter,
            env,
            CustomerService,
            phone,
            birthdate) {
        var vm = this;
        vm.env = env;
        vm.customer = null;
        vm.treatment = null;
        vm.treatmentId = null;

        
        vm.treatments = [
            {id: 2506, name: 'Pressomassaggio', description: 'Pressomassaggio 30 minuti', 'image': '/assets/images/treatments/pressoterapia.jpg', duration: 30},
            {id: 2508, name: 'Tratt. Essudativo', description: 'Trattamento Essudativo 30 minuti', 'image': '/assets/images/treatments/termosauna.jpg', duration: 30},
        ];
        localStorage.removeItem( 'Biolaser_token' );
        localStorage.removeItem( 'user' );

        $scope.$watch('booking.treatmentId', function(newValue, oldValue) {
            //if(newValue !== oldValue){
                vm.treatment = $filter('filter')(vm.treatments,{id: vm.treatmentId}, true)[0];
                console.log(vm.treatment);
            //}
        },true);

        vm.treatmentId = env.birthdayTreatmentId?env.birthdayTreatmentId:'2506';

        vm.treatment = $filter('filter')(vm.treatments,{id: vm.treatmentId}, true)[0];
        

        vm.getErrorMsg = function (response) {
            var msg = null;
            if (response.data != null && response.data.message != null) {
                msg = response.data != null && response.data.message != null ? "\n\nERRORE: " + response.data.message : "";
                msg += response.config != null && response.config.url != null ? "\nURL: " + response.config.url : "";
            }
            return msg;
        };
        //---------- customerdata -------------------------------------//

        vm.customerChecking = false;
        vm.checkCustomer = function () {
            if (vm.customer.phone == null
                || vm.customer.phone.trim() == '')
                return;
            vm.customerChecking = true;
            vm.customerLoaded = null;
            /**
             * Devo eseguire solo se il cell è valido
             */
            CustomerService.all({
                'search': 'phone:'+vm.customer.phone+';birthdate:'+vm.customer.birthdate,
                'searchFields': 'phone:=;birthdate:=',
            }, vm.env.API).then(
                    function (data) {
                        vm.customerChecking = false;
                        if (data.length >= 1) {
                            vm.customer = data[0];
                            vm.customerLoaded = true;
                            console.log("Ok: cid=" + vm.customer.id + " " + vm.customer.firstname);
                            ga('set', 'page', '/bd/checkcustomer');
                            ga('send', 'pageview');
                        } else {
                            alert("C'è stato un problema contattare il centro.");
                            ga('set', 'page', '/bd/checkcustomer/notfound');
                            ga('send', 'pageview');
                            vm.customerLoaded = false;
                        }
                    },
                    function (data) {
                        console.log(data);
                        var msg = vm.getErrorMsg(data);
                        alert("C'è stato un problema contattare il centro." + (msg != null ? " " + msg : ""));
                        vm.customerChecking = false;
                        ga('set', 'page', '/bd/checkcustomer/error');
                        ga('send', 'pageview');
                    }
            );
        };

        if (phone) {
            console.log("phone OK: "+phone);
            vm.customer = {phone: phone, birthdate: birthdate};
            vm.checkCustomer();
        }

        vm.treatmentChange = function() {
            console.log(vm.treatmentId);
        };
        vm.treatmentClick = function(t) {
            console.log(vm.treatmentId);
            vm.treatmentId = t;
            vm.openBooking();
        };
        vm.openBooking = function() {
            console.log(vm.customer.birthdate);
            var ts = moment(vm.customer.birthdate)
            console.log(ts);
            ts = ts.unix();
            console.log(ts);
            if (vm.env.bookings) {
                var url = vm.env.bookings[vm.customer.tenant]
                    +"/?customer="+vm.customer.phone
                    +"&bt="+ts
                    +"&treatment="+vm.treatmentId
                    +"&store="+vm.customer.last_store_id;
                window.location = url;
            } else {
                $state.go("booking", {
                    customer: vm.customer.phone,
                    bt: ts,
                    treatment: vm.treatmentId,
                    store: vm.customer.last_store_id
                });
            }
        };
        ga('set', 'page', '/bd');
        ga('send', 'pageview');
    };
})();

(function() {
  'use strict';

  angular
    .module('biolaser')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('biolaser')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    /*$stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });*/

    $urlRouterProvider.otherwise('/');
  }

})();

angular.module('biolaser')
.constant('env', {"tenant":"Napoli","company":"MadeInBeauty","domain":"madeinbeauty.it","info_email":"info@madeinbeauty.it","info_number":"800 974 975","privacy_url":"https://www.iubenda.com/privacy-policy/78347184","anonymous_access":true,"hideBanner":true,"hideStoreImages":true,"API":"https://api10.public.madeinbeauty.it/api","booking":"https://booking10.public.madeinbeauty.it","admin":"https://admin10.public.madeinbeauty.it","googleMap":{"key":"AIzaSyBz3Q2IkSJME5Az6ojDb_R3XFzoKE39zoU"}});

(function() {
    'use strict';

    angular
        .module('biolaser')
        .config(config)
    ;

    /** @ngInject */
    function config(
        env,
        $logProvider,
        $locationProvider,
        $authProvider,
        $provide,
        $httpProvider,
        uiGmapGoogleMapApiProvider,
        RestangularProvider
    ) {
        // Enable log
        $logProvider.debugEnabled( false );
        $locationProvider.html5Mode( true );
        /* Google Maps */
        if (!env.googleMap || env.googleMap.key) {
	        uiGmapGoogleMapApiProvider.configure({
	            key : env.googleMap?env.googleMap.key:'AIzaSyCtcc0wbPJDAGw1vdVnh7IgIaZcOLEPUZg'
	        });
        }
        /* Auth Settings */
        $authProvider.tokenPrefix = 'Biolaser';
        $authProvider.loginUrl = env.API+'/auth/token';
        /* Factory Interceptor */
        $provide.factory( 'redirectWhenLoggedOut', function( $q, $injector ) {
            return {
                responseError: function( rejection ) {
                    var rejectionReasons = [
                            'token_not_provided',
                            'token_expired',
                            'token_absent',
                            'token_invalid',
                        ]
                        , env =  $injector.get('env')
                        , $log =  $injector.get('$log')
                    ;
                	angular.forEach( rejectionReasons, function( value ) {
                        if( rejection.data ) {
                            if( rejection.data.error === value ) {
                            	/* Rimozione token in ogni caso o solo in quelli specificati nelle rejectionReasons? */
                                localStorage.removeItem( 'user' );
                                localStorage.removeItem( 'Biolaser_token' );
                                window.location.replace( env.booking + '/notauthorized?reason='+rejection.data.error );
                                //window.location.replace( env.admin + '/dashboard?logout=1' );
                            };
                        };
                    });
                    // if( rejection.data.status_code === 404 ) { alert("Elemento non trovato!"); };
                    return $q.reject( rejection );
                },
            };
        });
        $httpProvider.interceptors.push( 'redirectWhenLoggedOut' );
        // RestAngular
        RestangularProvider.setBaseUrl( env.API );
        RestangularProvider.setResponseExtractor( function( response ) {
            return response.data;
        });
        RestangularProvider.setDefaultHeaders( { 'Authorization': 'Bearer ' + localStorage.getItem( 'Biolaser_token' ) } );
    };
})();

angular.module("biolaser").run(["$templateCache", function($templateCache) {$templateCache.put("app/birthday/birthday.html","<div ng-if=\"!booking.config.data.disabled\" class=\"container page-booking\" ng-class=\"{isuser: booking.isUser, isclient: booking.isClient, isloading: booking.loading, islandingtreatment: booking.landing.treatment_id, islandingstore: booking.landing.store_id }\"><header class=\"main-header full-width\"><div class=\"message\" ng-if=\"booking.config.data.message\">{{booking.config.data.message}}</div><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div><div class=\"banner\" ng-if=\"!booking.env.hideBanner && !booking.isUser && !booking.env.apis\"></div></header><section><h1 class=\"title title-main\">Buon Compleanno</h1><div><div class=\"containerInner ui-sortable\" style=\"background-color: rgba(255, 255, 255, 0.9) !important;\"><div class=\"row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" id=\"row--39149\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"1 column row\" style=\"background-color: rgba(255, 255, 255, 0.9) !important; padding-top: 20px; padding-bottom: 0px; margin: 0px auto; outline: none; width: 80%; max-width: 100%;\"><div id=\"col-full-115-167\" class=\"col-md-12 innerContent col_left\" data-col=\"full\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"1st column\" style=\"outline: none;\"><div class=\"col-inner bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" style=\"padding: 0 10px\"><div class=\"de elSeperator elMargin0 ui-droppable de-editable\" id=\"tmp_divider-37408-128\" data-de-type=\"divider\" data-de-editing=\"false\" data-title=\"Divider\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 0px; outline: none; cursor: pointer; display: block;\" aria-disabled=\"false\"><div class=\"elDivider elDividerStyle1 padding10-top padding10-bottom\"><div class=\"elDividerInner\" style=\"border-color: rgb(108, 172, 228);\" data-width-border=\"50\" data-align=\"center\"></div></div></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-81726-158\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"main headline\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"outline: none; cursor: pointer; margin-top: -10px; display: block; font-family: Poppins, Helvetica, sans-serif !important;\" pt=\"\" sans=\"\" narrow=\"\" helvetica=\"\" sans-serif=\"\" aria-disabled=\"false\" data-google-font=\"Poppins\"><div class=\"ne elHeadline lh3 elMargin0 elBGStyle0 hsTextShadow0 hsSize4 padding0\" style=\"text-align: center; color: rgb(108, 172, 228); font-size: 24px;\" data-bold=\"inherit\" contenteditable=\"false\"><a name=\"selezione\"></a><font color=\"rgba(47, 57, 72, 0.949019607843137)\"><b>ECCO IL REGALO CHE MadeInBeauty HA PENSATO PER TE!</b></font></div></div><div class=\"de elSeperator elMargin0 ui-droppable de-editable\" id=\"divider-14102-113\" data-de-type=\"divider\" data-de-editing=\"false\" data-title=\"Divider\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: -18px; outline: none; cursor: pointer; display: block;\" aria-disabled=\"false\"><div class=\"elDivider elDividerStyle1 padding10-top padding10-bottom\"><div class=\"elDividerInner\" style=\"border-color: rgb(108, 172, 228);\" data-width-border=\"50\" data-align=\"center\"></div></div></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"tmp_paragraph-76837\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"Paragraph\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 5px; outline: none; cursor: pointer; font-family: Poppins, Helvetica, sans-serif !important;\" aria-disabled=\"false\" data-google-font=\"Poppins\"><div class=\"ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0\" data-bold=\"inherit\" style=\"margin-top: 20px; text-align: center; font-size: 22px;\" data-gramm=\"false\" contenteditable=\"false\">Scegli uno tra questi 2 trattamenti, e prenotalo gratis quando vuoi</div></div></div></div></div><div class=\"row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" id=\"row--18623\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"4 column row\" style=\"padding-top: 20px; padding-bottom: 20px; margin: 0px; outline: none;\"><div ng-click=\"booking.treatmentId = 2506\" id=\"col-center-right-116\" class=\"col-md-6 innerContent col_right ui-resizable\" data-col=\"right\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"3rd Column\" style=\"outline: none; overflow: hidden;\"><div class=\"col-inner bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" style=\"padding: 0 10px\"><div class=\"de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable\" id=\"img-67518\" data-de-type=\"img\" data-de-editing=\"false\" data-title=\"image\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 0px; outline: none; display: block; cursor: pointer;\" aria-disabled=\"false\"><img src=\"/assets/images/treatments/pressoterapia.jpg\" class=\"elIMG ximg\" alt=\"\" height=\"\" width=\"100%\" data-src=\"/assets/images/treatments/pressoterapia.jpg\" tabindex=\"0\"></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-38009\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"headline\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 10px; outline: none; cursor: pointer; font-family: Poppins, Helvetica, sans-serif !important;\" open=\"\" sans=\"\" helvetica=\"\" sans-serif=\"\" data-google-font=\"Poppins\" aria-disabled=\"false\"><div class=\"ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0\" style=\"text-align: center; font-size: 24px;\" data-bold=\"inherit\" contenteditable=\"false\"><b>Pressomassaggio</b></div></div><div class=\"de elSeperator elMargin0 ui-droppable de-editable\" id=\"divider-88119\" data-de-type=\"divider\" data-de-editing=\"false\" data-title=\"Divider\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 0px; outline: none; display: block; cursor: pointer;\" aria-disabled=\"false\"><div class=\"elDivider elDividerStyle1 padding10-top padding10-bottom\"><div class=\"elDividerInner\" data-width-border=\"50\" data-align=\"center\" data-height-border=\"2\" style=\"border-color: rgb(47, 47, 47);\"></div></div></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-42214\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"Paragraph\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 10px; outline: none; cursor: pointer;\" open=\"\" sans=\"\" helvetica=\"\" sans-serif=\"\" data-google-font=\"Open+Sans\" aria-disabled=\"false\"><div class=\"ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0\" data-bold=\"inherit\" style=\"text-align: center; font-size: 14px;\" contenteditable=\"false\">massaggio linfodrenante meccanico efficace contro la ritenzione idrica e la cellulite.</div></div></div></div><div ng-click=\"booking.treatmentId = 2508\" id=\"col-right-117\" class=\"col-md-6 innerContent col_right ui-resizable\" data-col=\"right\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"4th Column\" style=\"outline: none; overflow: hidden;\"><div class=\"col-inner bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" style=\"padding: 0 10px\"><div class=\"de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable\" id=\"img-28672\" data-de-type=\"img\" data-de-editing=\"false\" data-title=\"image\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 0px; outline: none; display: block; cursor: pointer;\" aria-disabled=\"false\"><img src=\"/assets/images/treatments/termosauna.jpg\" class=\"elIMG ximg\" alt=\"\" height=\"\" width=\"100%\" data-src=\"/assets/images/treatments/termosauna.jpg\" tabindex=\"0\"></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-53787\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"headline\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 10px; outline: none; cursor: pointer; font-family: Poppins, Helvetica, sans-serif !important;\" open=\"\" sans=\"\" helvetica=\"\" sans-serif=\"\" data-google-font=\"Poppins\" aria-disabled=\"false\"><div class=\"ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0\" style=\"text-align: center; font-size: 24px;\" data-bold=\"inherit\" contenteditable=\"false\"><b>Tratt. Essudativo</b></div></div><div class=\"de elSeperator elMargin0 ui-droppable de-editable\" id=\"divider-58468\" data-de-type=\"divider\" data-de-editing=\"false\" data-title=\"Divider\" data-ce=\"false\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 0px; outline: none; display: block; cursor: pointer;\" aria-disabled=\"false\"><div class=\"elDivider elDividerStyle1 padding10-top padding10-bottom\"><div class=\"elDividerInner\" data-width-border=\"50\" data-align=\"center\" data-height-border=\"2\" style=\"border-color: rgb(47, 47, 47);\"></div></div></div><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-77284\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"Paragraph\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 10px; outline: none; cursor: pointer;\" open=\"\" sans=\"\" helvetica=\"\" sans-serif=\"\" data-google-font=\"Open+Sans\" aria-disabled=\"false\"><div class=\"ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0\" data-bold=\"inherit\" style=\"text-align: center; font-size: 14px;\" contenteditable=\"false\">trattamento corpo efficace contro le adiposità localizzate e altamente detossinante.</div></div></div></div></div><div class=\"row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" id=\"row--29444\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"1 column row\" style=\"padding-top: 20px; padding-bottom: 20px; margin: 0px; outline: none;\"><div id=\"col-full-158\" class=\"col-md-12 innerContent col_left\" data-col=\"full\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" data-title=\"1st column\" style=\"outline: none;\"><div class=\"col-inner bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin\" style=\"padding: 0 10px\"><div class=\"de elHeadlineWrapper ui-droppable de-editable\" id=\"headline-53824\" data-de-type=\"headline\" data-de-editing=\"false\" data-title=\"Paragraph\" data-ce=\"true\" data-trigger=\"none\" data-animate=\"fade\" data-delay=\"500\" style=\"margin-top: 5px; outline: none; cursor: pointer; display: block; font-family: Poppins, Helvetica, sans-serif !important;\" aria-disabled=\"false\" data-google-font=\"Poppins\"><div class=\"ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0\" data-bold=\"inherit\" style=\"text-align: center; font-size: 22px;\" data-gramm=\"false\" contenteditable=\"false\">Puoi scegliere tra uno dei 2 trattamenti più richiesti quest\'anno da MadeInBeauty, prenoti il tuo appuntamento gratuito e vieni a trovarci comodamente.</div></div></div></div></div></div></div></section><form name=\"costumerForm\" role=\"form\" id=\"costumerForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"switch-boxes\"><div class=\"switch-item1\"><section class=\"row box box-treatments\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">SCEGLI E OTTIENI UN TRATTAMENTO GRATIS!!!</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\" ng-if=\"(!booking.treatmentIdParam) || ((booking.source | lowercase) != \'app\')\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><uib-tabset active=\"1\" justified=\"true\" class=\"custom-tabs\"><uib-tab index=\"1\"><uib-tab-heading>Effettua la tua scelta</uib-tab-heading><div class=\"custom-select\"><div ng-repeat=\"treatment in booking.treatments\" class=\"row custom-select-element {{booking.treatmentId && booking.treatmentId==treatment.id?\'active\':\'\'}}\" ng-model=\"booking.treatmentId\" uib-btn-radio=\"treatment.id\"><table><tr><td class=\"treatment-name\"><div class=\"treatment-title\">{{treatment.name}}</div><div class=\"treatment-time opacity-70\"><i class=\"icon-alarm\"></i> {{treatment.duration}} min</div></td></tr></table></div></div><div class=\"row treatment-list-separator\"><div class=\"col-xs-12\"><hr></div></div><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-check\"></i></div><input type=\"text\" name=\"treatment_selected\" class=\"form-control\" placeholder=\"Trattmento selezionato\" ng-model=\"booking.treatment.name\" ng-disabled=\"true\"></div><div class=\"tab-footer row\" ng-if=\"treatment.image\"><div class=\"tab-footer-image col-xs-12 col-sm-4\"><img ng-src=\"treatment.image\"></div><div class=\"tab-footer-description col-xs-12 col-sm-8\" ng-bind-html=\"treatment.description\"></div></div></uib-tab></uib-tabset></div></div></div></div></section><div class=\"cta-wrap centered\"><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.openBooking()\" ng-disabled=\"!booking.treatmentId || costumerForm.$invalid\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"booking.appointmentId==null\">Prenota ora</span></button></div></div></div><div class=\"footer full-width\" ng-if=\"!booking.isUser\">&copy; {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br><a href=\"{{booking.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div><footer class=\"main-header full-width\"><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div></footer></form></div>");
$templateCache.put("app/booking/booking.html","<div ng-if=\"booking.config.data.disabled\" class=\"container page-booking\" ng-class=\"{isuser: booking.isUser, isclient: booking.isClient, isloading: booking.loading, islandingtreatment: booking.landing.treatment_id, islandingstore: booking.landing.store_id }\"><header class=\"main-header full-width\"><div class=\"message\">Prenotazione momentaneamente disabilitata.</div><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div><div class=\"banner\" ng-if=\"!booking.isUser && !booking.env.apis\"></div></header></div><div ng-if=\"!booking.config.data.disabled\" class=\"container page-booking\" ng-class=\"{isuser: booking.isUser, isclient: booking.isClient, isloading: booking.loading, islandingtreatment: booking.landing.treatment_id, islandingstore: booking.landing.store_id }\"><header class=\"main-header full-width\"><div class=\"message\" ng-if=\"booking.config.data.message\">{{booking.config.data.message}}</div><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div><div class=\"banner\" ng-if=\"!booking.env.hideBanner && !booking.isUser && !booking.env.apis\"></div></header><section><h4 style=\"text-align: center; margin-left: 130px; margin-top: -50px;\'\" ng-if=\"booking.user!=null\">v{{booking.version}} | <b>{{ booking.env.apis?\'Italia\':booking.env.company }}</b> | <span ng-if=\"booking.user.type==\'operator\' || booking.user.type==\'storemngr\'\" class=\"operator-circle\" style=\"background-color: {{ booking.user.color }};\"></span> <span>{{booking.user.firstname}} {{booking.user.lastname}}</span> <span ng-if=\"booking.user.type!=\'operator\' && booking.user.type!=\'storemngr\'\">[{{booking.user.type}}]</span> <span ng-if=\"booking.user.type==\'operator\' || booking.user.type==\'storemngr\'\">[{{booking.user.store.alias}} <span ng-if=\"booking.user.type==\'storemngr\'\">*</span>]</span> <span ng-if=\"booking.leadId!=null\">| App. da lead</span> <span ng-if=\"booking.cusActId!=null\">| App. da rullo</span></h4><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId==null && (booking.tenantDataLoaded || booking.tenantFixed) && (booking.env.anonymous_access || booking.user)\" class=\"title title-main\">Prenota un appuntamento <span ng-if=\"booking.treatment && (booking.gender || booking.landing.treatment_id)\">{{booking.treatment.name}}</span><span ng-show=\"booking.env.apis\">| Area: {{ booking.tenant}}</span></h1><h6 ng-if=\"(booking.source | lowercase) == \'app\'\" class=\"title title-app-coupon\">Eventuali sconti verranno applicati al momento del pagamento.</h6><h1 class=\"title title-main\" style=\"font-size: 2.1rem;\" ng-if=\"booking.leadId && booking.campagna && (booking.tenantDataLoaded || booking.tenantFixed) && (booking.env.anonymous_access || booking.user)\">per la campagna <i>{{booking.campagna}}</i></h1><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId==null && !booking.tenantDataLoaded && booking.isUser && booking.user && booking.env.apis && !booking.tenantFixed\" class=\"title title-main\">Effettuare la scelta dell\'area per la prenotazione</h1><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId!=null && booking.isUser && booking.user\" class=\"title title-main\">Sposta appuntamento di {{booking.customer.firstname}} ({{booking.customer.phone}}) per {{booking.treatment.name}} del giorno {{booking.appointmentDate}} <span ng-show=\"booking.env.apis\">| Area: {{ booking.tenant}}</span></h1><h1 ng-if=\"booking.landing.treatment_id && !booking.user\" class=\"title title-main\">Benvenut* in {{booking.env.company}}</h1><h1 ng-if=\"booking.landing.treatment_id\" class=\"title title-main\"><span ng-if=\"booking.appointment.id\">Sposta</span> {{booking.landing.title}}</h1><div ng-if=\"booking.landing.treatment_id && booking.landing.description\" ng-bind-html=\"booking.landing.description\"></div><h4 style=\"text-align: center;\" ng-if=\"booking.landing.treatment_id && booking.appointment.id\">La prenotazione precedente era fissata per il {{booking.appointmentDate}}</h4><h4 style=\"text-align: center;\">* Campi Obbligatori</h4><md-progress-circular style=\"text-align: center; margin: 50px;\" md-mode=\"indeterminate\" ng-if=\"booking.loadingTreatments\"></md-progress-circular></section><form name=\"costumerForm\" role=\"form\" id=\"costumerForm\" autocomplete=\"off\" novalidate=\"\"><section class=\"row box box-tenant-data centered\" ng-if=\"!booking.user && booking.initialized && (booking.env.apis || booking.env.anonymous_access===false)\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Inserisci le credenziali di accesso</h3></div><div class=\"col-md-12 box-body centered\"><div class=\"user-select\" ng-if=\"true\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.email.$touched && costumerForm.email.$invalid }\"><label for=\"email\" class=\"label-input\">Email:</label> <input ng-disabled=\"booking.loading || booking.user\" id=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" ng-model=\"booking.loginEmail\" required=\"\"><div class=\"help-block\" ng-messages=\"costumerForm.email.$error\" ng-show=\"costumerForm.email.$touched\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.password.$touched && costumerForm.password.$invalid }\"><label for=\"password\" class=\"label-input\">Password:</label> <input ng-disabled=\"booking.loading || booking.user\" id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"booking.loginPassword\" required=\"\"><div class=\"help-block\" ng-messages=\"costumerForm.password.$error\" ng-show=\"costumerForm.password.$touched\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div></div><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.doLogin()\" ng-disabled=\"booking.loading || booking.user || costumerForm.$invalid\"><img src=\"assets/images/loading.svg\"> <span>Entra</span></button></div></section><section class=\"row box box-tenant-data centered\" ng-if=\"booking.isUser && booking.user && booking.env.apis && !booking.tenantFixed\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Scelta area</h3></div><div class=\"col-md-12 box-body centered\"><div class=\"row\"><radio-buttons ng-show=\"booking.isUser\" options=\"booking.tenantsList\" ng-model=\"booking.tenant\" ng-click=\"booking.changeTenant()\"></radio-buttons></div><div><h2>Area scelta: <b>{{booking.tenant}}</b></h2></div><br><span>{{booking.tenantMsg}}</span><br><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.confirmTenant()\" ng-disabled=\"booking.loading || !booking.tenant || booking.tenantDataLoaded\"><img src=\"assets/images/loading.svg\"> <span>Conferma</span></button></div></section><div class=\"switch-boxes\" ng-class=\"{ reverse: booking.isUser || booking.referral }\"><div class=\"switch-item1\" ng-if=\"booking.tenantDataLoaded && (!booking.env.tenant==\'Italia\' || booking.user || !booking.isUser)\"><section class=\"row box box-client\" ng-if=\"!booking.referral && !(booking.customerId && booking.landing) && !booking.birthdate && !booking.isUser && (booking.env.anonymous_access && booking.treatmentsList.length>0)\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.isClientTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><radio-buttons options=\"booking.isClientList\" ng-model=\"booking.isClient\"></radio-buttons></div><div class=\"step_number\"><strong>{{ booking.isClientStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><section class=\"row box box-customer-data\" ng-if=\"!(booking.landing && booking.customerId) && booking.appointmentId==null && (booking.env.anonymous_access && booking.treatmentsList.length>0) || booking.user\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-show=\"booking.isUser && booking.customerId\">Dati di <span>{{booking.customer.firstname}}</span></h3><h3 class=\"title\" ng-show=\"!booking.isUser\">Lascia i tuoi <span>dati</span></h3><h3 class=\"title\" ng-show=\"booking.isUser && !booking.customerId\">Inserisci i dati del <span>cliente</span></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div class=\"form-group required\"><div ng-if=\"!booking.referral && !booking.isUser && (!booking.env.captcha || booking.env.captcha.key)\" vc-recaptcha=\"\" key=\"!booking.env.captcha?\'6LfLty4UAAAAAGRLmlN7G7csoOGGLe75Q0ewkY9D\':booking.env.captcha.key\" ng-model=\"booking.captcha\" theme=\"light\" size=\"normal\" type=\"\'image\'\" lang=\"it\"></div></div></div></div><div class=\"row\"><h1 ng-if=\"booking.isUser && booking.existLeadComm && booking.existLeadComm.user_id\" class=\"col-xs-12 has-error title title-main col-md-12\">Lead Commerciale gestito da {{booking.existLeadComm.user.data.lastname }} {{booking.existLeadComm.user.data.firstname }} N° Tel. {{booking.existLeadComm.user.data.phone }}</h1><h1 ng-if=\"booking.isUser && booking.existLeadComm && !booking.existLeadComm.user_id\" class=\"col-xs-12 has-error title title-main col-md-12\">Lead Commerciale gestito da NUMERO VERDE {{ booking.env.info_number }}</h1><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div ng-if=\"booking.isUser && booking.customer && booking.customer.f_guarantee\" class=\"form-group row\"><h3 class=\"title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"currentColor\" class=\"bi bi-shield-check\" viewbox=\"0 0 16 16\"><path d=\"M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z\"></path><path d=\"M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z\"></path></svg>&nbsp;Garanzia attiva: {{booking.customer.guarantee_at_frmt }}</h3></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.phone.$invalid && costumerForm.phone.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone\" name=\"phone\" class=\"form-control\" placeholder=\"Cellulare\" ng-model=\"booking.customer.phone\" ng-disabled=\"booking.cantChangeCustomer || (!booking.referral && !booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" ng-pattern=\"/^[0-9]{9}[0-9]?[0-9]?[0-9]?$/\" ng-blur=\"booking.checkCustomer()\" required=\"\"></div><div ng-show=\"booking.customerChecking\"><i class=\"icon-cached\"></i>Caricamento in corso ...</div><div class=\"help-block\" ng-messages=\"costumerForm.phone.$error\" ng-show=\"costumerForm.phone.$touched\"><div ng-message=\"pattern\" ng-show=\"costumerForm.phone.$error.pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono(9 o 10 cifre) senza spazi ne altri caratteri.</div></div><span class=\"small-txt\">il cellulare &egrave; necessario per confermare l\'appuntamento</span></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (costumerForm.firstname.$touched && costumerForm.firstname.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"booking.customer.firstname\" ng-maxlength=\"30\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || (!booking.isUser && booking.customer && booking.customer.id) || (!booking.referral && !booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" required=\"\"></div><div class=\"help-block\" ng-messages=\"costumerForm.firstname.$error\" ng-show=\"costumerForm.firstname.$touched\" ng-messages-multiple=\"\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"row\"><h6 ng-if=\"(booking.source | lowercase) == \'app\'\" class=\"title title-app-coupon title-app-coupon-last\">Eventuali sconti verranno applicati al momento del pagamento.</h6></div><div ng-if=\"booking.isUser || !booking.customer.id\" class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.lastname.$touched && costumerForm.lastname.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"booking.customer.lastname\" ng-maxlength=\"30\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || (!booking.referral && !booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" required=\"\"></div><div class=\"help-block\" ng-messages=\"costumerForm.lastname.$error\" ng-show=\"costumerForm.lastname.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.isUser || !booking.customer.id\" class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.email.$touched && costumerForm.email.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-markunread\"></i></div><input type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" ng-model=\"booking.customer.email\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || (!booking.referral && !booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" required=\"\"></div><div class=\"help-block\" ng-messages=\"costumerForm.email.$error\" ng-show=\"costumerForm.email.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.isUser || !booking.customer.id\" class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.birthdate.$touched && costumerForm.birthdate.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-today\"></i></div><input type=\"date\" name=\"birthdate\" class=\"form-control\" placeholder=\"Data di nascita\" ng-model=\"booking.customer.birthdate\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || (!booking.referral && !booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" max=\"{{booking.maxBirthDate | date:\'yyyy-MM-dd\'}}\" required=\"\"></div><div class=\"help-block\" ng-messages=\"costumerForm.birthdate.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.isUser\" class=\"form-group\"><p>Modalit&agrave; di notifica</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-notifications\"></i></div><md-input-container style=\"border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; border-right: 1px solid #ddd; margin: 0px; padding: 0px; text-align: left;\"><md-checkbox style=\"width: 100%; margin-bottom: 1px solid #ddd;\" name=\"f_notify_wa\" ng-model=\"booking.customer.f_notify_wa\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-true-value=\"1\" ng-false-value=\"0\"><span>Whatsapp</span></md-checkbox><md-checkbox style=\"width: 100%; margin-bottom: 1px solid #ddd;\" name=\"f_notify_sms\" ng-model=\"booking.customer.f_notify_sms\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-true-value=\"1\" ng-false-value=\"0\"><span>SMS</span></md-checkbox><md-checkbox style=\"width: 100%;\" name=\"f_notify_email\" ng-model=\"booking.customer.f_notify_email\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-true-value=\"1\" ng-false-value=\"0\"><span>Email</span></md-checkbox></md-input-container></div></div><div ng-if=\"booking.isUser\" class=\"form-group\" ng-class=\"{ \'has-error\': costumerForm.referral_code.$touched && costumerForm.referral_code.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"referral_code\" class=\"form-control\" placeholder=\"Codice acquisizione\" ng-disabled=\"true\" ng-model=\"booking.user.user_alias\"></div></div><div ng-if=\"booking.isUser && booking.sourcesList!=null && booking.customer.id == null\" class=\"form-group\"><p>Campagna</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-autorenew\"></i></div><select ng-model=\"booking.customer.campaign\" class=\"form-control\" ng-disabled=\"booking.customerChecking\"><option value=\"\"></option><option ng-value=\"val\" ng-repeat=\"val in booking.sourcesList\">{{ val }}</option></select></div></div><div ng-if=\"booking.isUser\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"user_times\" class=\"form-control\" ng-disabled=\"true\" ng-model=\"booking.user_times_descr\"></div></div><div ng-if=\"booking.referral && booking.customer || booking.isUser && !booking.customer.src_cid\" class=\"form-group\" ng-class=\"{ \'has-error\': costumerForm.src_phone.$touched && costumerForm.src_phone.$invalid }\"><p>Segnalato da</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" name=\"src_phone\" class=\"form-control\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || !booking.isUser || !booking.referralCan || booking.customer.src_cid\" placeholder=\"Telefono referral\" ng-model=\"booking.customer.src_phone\" ng-pattern=\"/^[0-9]{9}[0-9]?[0-9]?[0-9]?$/\" ng-blur=\"booking.checkSrcCustomer()\"></div><div ng-show=\"booking.srcCustomerChecking\"><i class=\"icon-cached\"></i>Caricamento in corso ...</div><div class=\"help-block\" ng-messages=\"costumerForm.src_phone.$error\" ng-show=\"costumerForm.src_phone.$touched\"><div ng-message=\"pattern\" ng-show=\"costumerForm.src_phone.$error.pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono(9 o 10 cifre) senza spazi ne altri caratteri.</div></div><div class=\"help-block\" ng-show=\"!booking.srcCustomer.id && booking.srcCustomerLoaded\"><div class=\"has-error\">Segnalante non trovato</div></div><div class=\"help-block\" ng-show=\"!booking.referralCan\"><div class=\"has-error\">{{booking.referralMsg}}</div></div></div><div class=\"form-group required\" ng-if=\"booking.customer.src_phone && booking.customer && booking.isUser && !booking.customer.src_cid\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"src_firstname\" class=\"form-control\" placeholder=\"Nome Segnalante\" ng-model=\"booking.srcCustomer.firstname\" ng-disabled=\"true\" ng-required=\"booking.customer.src_phone\"></div></div><div ng-if=\"booking.isUser && booking.customer && booking.customer.src_cid && booking.customer.sourceCustomer\" class=\"form-group\"><p>Segnalato da</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" name=\"src_phone\" class=\"form-control\" ng-disabled=\"true\" placeholder=\"Telefono referral\" ng-model=\"booking.customer.sourceCustomer.data.phone\"></div><div class=\"help-block\"><div>{{booking.customer.sourceCustomer.data.firstname}} {{booking.customer.sourceCustomer.data.lastname}}</div></div><div class=\"help-block\" ng-show=\"!booking.referralCan\"><div class=\"has-error\">{{booking.referralMsg}}</div></div></div><div ng-if=\"booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate\" class=\"form-group\"><p>Sfrutta un abbonamento attivo</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-autorenew\"></i></div><select ng-model=\"booking.customer_subscription_id\" ng-change=\"booking.customerSubscriptionIdChange()\" class=\"form-control\" ng-disabled=\"booking.customerChecking\"><option value=\"\"></option><option ng-repeat=\"subscription in booking.customer.customer_subscriptions_active track by subscription.id\" value=\"{{subscription.id}}\"><span ng-if=\"subscription.subscription_id!=1000\">{{subscription.subscription_id | subscriptionIdtoName:booking.subscriptionsList:subscription.app_remaining}}</span> <span ng-if=\"subscription.subscription_id==1000 && subscription.quotation && subscription.quotation.data\">Piano personalizzato n.{{subscription.quotation.data.id}} {{subscription.quotation.data.note}} (rimaste {{subscription.app_remaining}})</span></option></select></div></div><div ng-if=\"booking.tenantDataLoaded && booking.isUser && !booking.landing.treatment_id\" class=\"form-group\"><p>Crea un nuovo abbonamento</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-autorenew\"></i></div><select ng-model=\"booking.subscription_new_id\" ng-change=\"booking.subscriptionNewIdChange()\" class=\"form-control\" ng-disabled=\"booking.customerChecking\"><option value=\"\"></option><option ng-value=\"subscriptionNew.id\" ng-repeat=\"subscriptionNew in booking.subscriptionsList | filter: {active: 1}: true | orderBy: \'name\'\">{{ subscriptionNew.name }}</option></select></div></div></div></div><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.insertPf()\" ng-if=\"booking.isUser && booking.tenantDataLoaded && booking.customer && booking.customer.phone && !booking.existLeadComm\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"true\">Inserisci Phone Friend</span></button><div ng-if=\"booking.isUser\" class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Note Cliente</h3></div><div ng-if=\"booking.isUser\" class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"input-group-addon\"><i class=\"icon-event_note\"></i></div><textarea id=\"note\" name=\"note\" class=\"form-control\" placeholder=\"Note\" rows=\"3\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-model=\"booking.customer.note\"></textarea></div></div></div><div ng-if=\"booking.isUser && booking.tenantDataLoaded && !booking.existLeadComm\" class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Appuntamenti Precedenti</h3></div><div ng-if=\"booking.isUser && booking.tenantDataLoaded && !booking.existLeadComm\" class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"custom-select custom-select-boxed app_prec\"><table width=\"100%\"><tr class=\"app_prec_tr_h\"><td>Op.</td><td>Trattamento</td><td>Centro</td><td>Data ora</td><td>Spost./Disd.</td><td>Presentato</td><td>&euro;</td></tr><tr ng-repeat=\"app in booking.customer.appointments.data | orderBy : app.date_start : true\" style=\"text-align: left; width: 100%;\" ng-class-even=\"\'app_pren_even\'\"><td width=\"3%\"><span ng-if=\"app.role && app.role.data\" class=\"operator-circle\" style=\"background-color: {{ app.role.data.color }};\"></span></td><td width=\"27%\"><strong>{{app.treatment.data.name}}</strong></td><td width=\"25%\"><strong>{{app.store.data.alias}}</strong></td><td width=\"20%\"><strong>{{app.date_start_frmt}}</strong></td><td width=\"10%\"><strong>{{app.recalled==3?\'DISD\':(app.recalled==4?\'SPOST\':\'\')}}</strong></td><td width=\"10%\"><strong>{{((app.paid == 1)? \'SI\': ((app.paid == 0)? \'NO\' : \'N/D\'))}}</strong></td><td width=\"10%\"><strong><span ng-if=\"app.paid\">{{app.price}}&euro;</span></strong></td></tr></table><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco appuntamenti precendenti</div></div></div><div class=\"no-availability\" ng-show=\"booking.customer.appointments.data.length==0\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessun appuntamento</div></div></div></div></div><div class=\"help-block\" ng-show=\"!booking.isUser && !booking.referralCan && booking.referralMsgDetail\"><div class=\"has-error\" ng-bind-html=\"booking.referralMsgDetail\"></div></div></div><div class=\"step_number\"><strong>{{ booking.customerDataStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><section class=\"row box box-treatments\" ng-show=\"!(booking.landing && booking.customerId && (!booking.landing.landing_treatments || booking.landing.landing_treatments.length<=1)) && !booking.birthdate && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.treatmentsTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><radio-buttons ng-show=\"!booking.landing.treatment_id\" options=\"booking.gendersList\" ng-model=\"booking.gender\" required=\"\"></radio-buttons><br><radio-buttons ng-show=\"booking.isUser\" options=\"booking.typeAppList\" ng-model=\"booking.typeApp\"></radio-buttons><div class=\"row\" ng-if=\"booking.treatmentIdParam && ((booking.source | lowercase) == \'app\')\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-check\"></i></div><input type=\"text\" name=\"treatment_selected\" class=\"form-control\" placeholder=\"Trattmento selezionato\" ng-model=\"booking.treatment.name\" ng-disabled=\"true\"></div></div></div><div class=\"row\" ng-if=\"((!booking.treatmentIdParam) || ((booking.source | lowercase) != \'app\')) && (booking.gender || booking.landing.treatment_id)\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><uib-tabset active=\"booking.active_treatment_category_id\" justified=\"true\" class=\"custom-tabs\"><uib-tab ng-repeat=\"tab in booking.treatmentsList\" index=\"tab.id\" ng-hide=\"booking.landing.treatment_id && booking.landing.landing_treatments.data.length==0\" ng-if=\"tab | showTabFilter:booking.gender:booking.landing\"><uib-tab-heading><div class=\"mini-txt\">trattamento</div>{{tab.name}}</uib-tab-heading><div class=\"input-group\" style=\"margin-top: 20px;\"><div class=\"input-group-addon\"><i class=\"icon-search\"></i></div><input type=\"text\" name=\"search_treatment\" class=\"form-control\" placeholder=\"\" ng-model=\"booking.search_treatment\" ng-disabled=\"false\"></div><div class=\"custom-select\"><div ng-repeat=\"treatment in tab.treatments.data | filter: {\'active\':1} : true | searchTreatment:tab.id:booking.treatment:booking.search_treatment | getGenderTreatmentsFilter:booking.gender:booking.landing | orderBy: [\'order\',\'name\']\" class=\"row custom-select-element {{booking.treatmentId==treatment.id?\'active\':\'\'}}\" ng-model=\"booking.treatmentId\" uib-btn-radio=\"treatment.id\"><table><tr><td class=\"treatment-name\"><div class=\"treatment-title\">{{treatment.name}}</div><div class=\"treatment-time opacity-70\"><i class=\"icon-alarm\"></i> {{treatment.duration}} min</div></td><td class=\"treatment-details\" ng-if=\"booking.env.show_price==undefined || booking.env.show_price\"><div class=\"treatment-price\" ng-if=\"booking.landing.price\" ng-bind-html=\"booking.treatmentPrice | labelRadioButtonFilter: \'euro\'\"></div><div class=\"treatment-price\" ng-if=\"!booking.landing.price && !booking.typeApp\" ng-bind-html=\"treatment.start_price | labelRadioButtonFilter: \'euro\'\"></div><div class=\"treatment-price\" ng-if=\"!booking.landing.price && booking.typeApp==\'promo\'\"><span ng-show=\"treatment.promo_price || treatment.start_price\" class=\"mini-txt mini-euro\">&euro;</span>{{(treatment.promo_price?treatment.promo_price:treatment.start_price*0.75) | number:0}}</div><div class=\"treatment-price\" ng-if=\"!booking.landing.price && booking.typeApp==\'free\'\">0</div></td></tr></table></div></div><div class=\"row treatment-list-separator\"><div class=\"col-xs-12\"><hr></div></div><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-check\"></i></div><input type=\"text\" name=\"treatment_selected\" class=\"form-control\" placeholder=\"Trattmento selezionato\" ng-model=\"booking.treatment.name\" ng-disabled=\"true\"></div><div class=\"tab-footer row\" ng-if=\"false && !booking.isUser\"><div class=\"tab-footer-image col-xs-12 col-sm-4\"><img ng-src=\"{{booking.treatment.image}}\"></div><div class=\"tab-footer-description col-xs-12 col-sm-8\" ng-bind-html=\"booking.treatment.description\"></div></div></uib-tab></uib-tabset></div></div></div><div class=\"step_number\"><strong>{{ booking.treatmentsStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><section class=\"row box box-stores\" ng-if=\"booking.storesList.length>0 && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.storesTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"form-group row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><span ng-if=\"booking.storeIdParam && ((booking.source | lowercase) == \'app\')\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-location_city\"></i></div><input type=\"text\" class=\"form-control\" ng-value=\"(booking.store.name+\' - \'+booking.store.city+\' - \'+booking.store.address)\" ng-disabled=\"true\"></div></span> <span ng-if=\"((!booking.storeIdParam) || (booking.source | lowercase) != \'app\')\"><label for=\"storesList\" class=\"label-input\">Scegli un centro *</label><select ng-disabled=\"booking.loading || booking.monthAvailability.loading\" class=\"form-control select-store\" id=\"storesList\" ng-model=\"booking.store\" ng-options=\"(store.name+\' - \'+store.city+\' - \'+store.address) group by store.city for store in booking.storesList | filter : {active: 1}: true\" ng-change=\"booking.storeSelected()\"></select></span><div class=\"cta-wrap call-wrap centered\" ng-if=\"booking.storeId && !booking.store.booking_online\"><h3>In questo centro puoi solamente <strong>prenotare telefonicamente</strong></h3><a class=\"or-call centered\" ng-if=\"!booking.isUser\" href=\"tel:{{booking.store.phone}}\"><div class=\"call-icon\"><i class=\"icon-phone\"></i></div><div class=\"call-info\"><div class=\"call-number\">{{booking.store.phone}}</div></div><div class=\"clearfix\"></div></a></div><div class=\"user-select\" ng-if=\"booking.config.data.selectoper_enabled && booking.store.booking_online\"><label for=\"usersList\" class=\"label-input\">Scegli una operatrice</label><md-select ng-disabled=\"booking.loading || booking.monthAvailability.loading\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"usersList\" aria-label=\"Selezione operatrice\" ng-model=\"booking.operator.id\" ng-change=\"booking.operatorSelected()\"><md-option value=\"\"></md-option><md-option ng-value=\"op.user_id\" ng-repeat=\"op in booking.rolesList | filter:{treatmentEnabled:true}:true track by op.id | orderBy: \'user.firstname\': true\"><span ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ op.color }};\"></span>{{ op.user.firstname }} <span ng-if=\"booking.isUser\">{{ op.user.lastname }}</span> <span ng-if=\"!booking.isUser\">{{ op.user.lastname!=null && op.user.lastname.substring(0,1) + \'.\' }}</span></md-option></md-select></div><div class=\"user-select\" ng-if=\"(booking.env.show_price==undefined || booking.env.show_price) && booking.store.booking_online && (booking.isCallCenter || booking.userRole==\'storemngr\')\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': costumerForm.priceOverride.$touched && costumerForm.priceOverride.$invalid }\" ng-if=\"(booking.isCallCenter || booking.userRole==\'storemngr\')\"><label for=\"priceOverride\" class=\"label-input\">Sovrascrivi il prezzo del trattamento (&euro;)</label> <input ng-disabled=\"booking.loading || booking.monthAvailability.loading\" type=\"number\" id=\"priceOverride\" name=\"priceOverride\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Sovrascrivi Prezzo Servizio\" ng-model=\"booking.priceOverride\" required=\"\"><div class=\"help-block\" ng-messages=\"costumerForm.priceOverride.$error\" ng-show=\"costumerForm.priceOverride.$touched\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div></div></div></div><div ng-if=\"!booking.env.hideStoreImages && !booking.isUser\"><div class=\"selected-line\"><span>{{booking.store.name}}</span> - {{booking.store.city}} - {{booking.store.address}}<br><a class=\"btn btn-default btn-sm navigate\" target=\"_blank\" href=\"https://maps.google.com?daddr={{booking.store.coordinates.latitude}},{{booking.store.coordinates.longitude}}\"><i class=\"icon-near_me\"></i>Indicazioni</a></div><ui-gmap-google-map ng-if=\"!booking.env.googleMap || booking.env.googleMap.key\" class=\"disable-map\" center=\"booking.store.coordinates\" zoom=\"booking.map.zoom\" options=\"booking.map.options\"><ui-gmap-markers models=\"booking.storesList\" coords=\"\'coordinates\'\" icon=\"\'icon\'\"></ui-gmap-markers></ui-gmap-google-map><div class=\"gallery row\"><div class=\"pic col-xs-6 col-sm-3\" ng-repeat=\"image in booking.store.gallery\"><a ng-click=\"booking.openLightboxModal($index)\"><img ng-src=\"{{image.thumbUrl}}\"></a></div></div></div></div><div class=\"step_number\"><strong>{{ booking.storesStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><div class=\"centered\" ng-if=\"!(booking.landing && !booking.user) && booking.store.booking_online && !booking.existLeadComm\"><button id=\"btn-load_ava\" class=\"btn btn-success btn-mega\" ng-click=\"booking.monthAvailability.load()\" ng-disabled=\"booking.storeId == null || (booking.isUser && booking.customer == null) || (booking.isUser && booking.customer.phone == null) || booking.monthAvailability.loading || booking.monthAvailability.isCurrentYmLoaded || booking.loadingTreatments\"><img src=\"assets/images/loading.svg\"><span>Cerca disponibilit&agrave;</span></button></div><section class=\"row box box-datetime\" ng-if=\"booking.store.booking_online && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.dateTimeTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><table ng-if=\"booking.isUser && booking.debug\" class=\"capabilities col-md-offset-2 col-md-8\"><thead><tr><td></td><td></td><td>Man.</td><td style=\"text-align: right;\">Redd/H.</td><td style=\"text-align: right;\">Scontr. M.P.</td><td style=\"text-align: right;\">Max App.</td></tr></thead><tbody><tr ng-repeat=\"role in booking.rolesList | orderBy : \'c_capability.check_m_pond\' : true\" ng-click=\"booking.operatorFilter(role)\" class=\"{{ role.user_id == booking.operator.id ? \'selected\': (role.c_capability.man==0?\'disabled\':\'\') }}\"><td><div class=\"operator-circle\" style=\"background-color: {{ role.color }};\"></div></td><td><span data-tooltip=\"uid={{ role.user_id }}\">{{ role.user.firstname }} {{ role.user.lastname }}</span></td><td><ng-rate-it ng-model=\"role.c_capability.man\" read-only=\"true\" min=\"0\" max=\"3\"></ng-rate-it></td><td style=\"text-align:right;\"><span>{{ role.c_capability.reddh }}</span></td><td style=\"text-align:right;\"><span>{{ role.c_capability.check_m_pond }}</span></td><td style=\"text-align:right;\"><span>{{ role.c_capability.max_daily_app }}</span></td></tr></tbody></table><div class=\"row\"><div class=\"{{ booking.isUser ? \'col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\': \'col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\' }}\"><div class=\"calendar-box\"><span ng-if=\"booking.isUser && booking.gp!=null && booking.gp!=0\" class=\"opacity-70\">Groupon prenotati il {{ booking.date4Labels.format(\'DD/MM/YYYY\') }}:</span> <strong ng-if=\"booking.isUser && booking.gp!=null && booking.gp!=0\">{{ booking.gp }}</strong><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\"><img src=\"assets/images/loading.svg\"></div></div></div><uib-datepicker ng-model=\"booking.date\" ng-change=\"booking.dateSelected()\" datepicker-options=\"booking.inlineOptions\" class=\"custom-datepicker well well-sm\"></uib-datepicker></div><div ng-if=\"booking.config.data.overbooking_enabled && booking.isOver\"><h4>{{ booking.date_frmt }}</h4></div><div><h3>{{booking.event2Show.title}}</h3><p><b>{{booking.event2Show.note}}</b></p></div><div layout=\"row\" layout-align=\"center\" ng-if=\"booking.config.data.overbooking_enabled && booking.isUser && booking.treatmentId && (booking.user_type == \'callcenter\' && !booking.treatment.over_enabled) && booking.store && booking.date && booking.customer\"><md-input-container layout=\"row\" class=\"md-block\"><md-checkbox ng-disabled=\"\'true\'\"><b>Overbooking non abilitato</b> per <b>{{ booking.treatment.name }}</b></md-checkbox></md-input-container></div><div class=\"user-select\" ng-if=\"booking.config.data.overbooking_enabled && booking.store.booking_online && booking.isOver\"><label for=\"usersList2\" class=\"label-input\">Scegli una operatrice</label><md-select ng-disabled=\"booking.loading || booking.monthAvailability.loading\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"usersList2\" aria-label=\"Selezione operatrice\" ng-model=\"booking.operator.id\" ng-change=\"booking.operatorSelected()\"><md-option value=\"\"></md-option><md-option ng-value=\"op.user_id\" ng-repeat=\"op in booking.rolesList track by op.id | orderBy: \'user.firstname\': true\"><span ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ op.color }};\"></span> {{ op.user.firstname }} <span ng-if=\"booking.isUser\">{{ op.user.lastname }}</span> <span ng-if=\"!booking.isUser\">{{ op.user.lastname!=null && op.user.lastname.substring(0,1) + \'.\' }}</span></md-option></md-select></div><div layout=\"row\" layout-align=\"center\" ng-if=\"booking.config.data.overbooking_enabled && booking.isUser && booking.treatmentId && (booking.user_type != \'callcenter\' || booking.treatment && booking.treatment.over_enabled) && booking.store && booking.date && booking.customer\"><md-input-container layout=\"row\" class=\"md-block\" flex=\"40\"><md-checkbox ng-model=\"booking.isOver\">Overbooking</md-checkbox></md-input-container><md-input-container layout=\"row\" class=\"md-block\" flex=\"40\" ng-if=\"booking.isOver\" style=\"font-size: 1.2em; text-align: center; margin-top: 30px;\"><input mdc-datetime-picker=\"\" disable-parent-scroll=\"true\" today-btn=\"false\" short-time=\"true\" date=\"false\" type=\"text\" id=\"startTime\" time=\"true\" placeholder=\"Ora inizio\" format=\"HH:mm\" ng-model=\"booking.overDateStart\" ng-disabled=\"!booking.operator.id\"></md-input-container></div></div></div><div class=\"row\"><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date1_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div class=\"custom-select-element\" ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date1}: true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\"><div ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">alle</span> <strong>{{availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span ng-if=\"availability.sales_specialist && booking.isUser\" style=\"color: gold;\"><i class=\"icon-priority_high\"></i></span> <span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-group\"></i> {{availability.meet_available}} posti</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date2_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div class=\"custom-select-element\" ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date2} : true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\"><div ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">alle</span> <strong>{{availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span ng-if=\"availability.sales_specialist && booking.isUser\" style=\"color: gold;\"><i class=\"icon-priority_high\"></i></span> <span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-school\"></i> {{availability.meet_available}} posti</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date3_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div class=\"custom-select-element\" ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date3} : true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\"><div ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">alle</span> <strong>{{availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span ng-if=\"availability.sales_specialist && booking.isUser\" style=\"color: gold;\"><i class=\"icon-priority_high\"></i></span> <span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-school\"></i> {{availability.meet_available}} posti</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div></div><div class=\"col-xs-10 col-md-6 col-md-offset-3\" ng-if=\"booking.isOver && booking.isUser\"><div class=\"custom-select custom-select-boxed app_pren\"><table width=\"100%\"><tr class=\"app_pren_tr_h\"><td colspan=\"5\">Appuntamenti prenotati</td></tr><tr ng-repeat=\"app in booking.appointmentsToShowList\" style=\"text-align: left; width: 100%;\" ng-class-even=\"\'app_pren_even\'\"><td width=\"8%\" style=\"text-align: center;\"><div ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ app.role.data.color }};\"></div></td><td width=\"20%\"><span class=\"opacity-70\">dalle</span> <strong>{{app.date_start | splitTimeFilter | limitTo:5 }}</strong></td><td width=\"10%\"><i ng-if=\"booking.appHaveOverlap(app)\" class=\"icon-error_outline blink\"></i></td><td width=\"20%\"><span class=\"opacity-70\">alle</span> <strong>{{app.date_end | splitTimeFilter | limitTo:5}}</strong></td><td width=\"42%\"><i ng-if=\"app.user_times<=1\" style=\"color: green;\" class=\"icon-input\"></i> <i ng-if=\"app.f_over>0\" style=\"color: red;\" class=\"icon-grid_off\"></i> <strong>{{app.treatment.data.name}}</strong></td></tr></table><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco appuntamenti</div></div></div><div class=\"no-availability\" ng-show=\"booking.appointmentsToShowList.length==0\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessun appuntamento</div></div></div><div class=\"row radio-buttons-box\" ng-if=\"!booking.isOver\"><div class=\"col-md-12\"><radio-buttons options=\"booking.dayMomentList\" ng-model=\"booking.dayMoment\" ng-click=\"booking.momentSelected()\"></radio-buttons></div><div class=\"col-md-12\" ng-if=\"booking.reservedEnabled && booking.isUser\"><radio-buttons options=\"booking.reservedOptionsList\" ng-model=\"booking.reserved\" ng-click=\"booking.reservedSelected()\"></radio-buttons></div></div><div class=\"row fadein fadeout\" ng-show=\"!booking.isUser && booking.availability && !(booking.landing && booking.customerId)\"><div class=\"col-md-12\"><h3 class=\"title resume-sentence\"><span class=\"opacity-70\">Il trattamento</span> <strong>{{booking.treatment.name }}</strong> <span class=\"opacity-70\">sar&agrave; eseguito</span> <strong ng-if=\"booking.birthdate\">in Omaggio</strong> <span ng-if=\"!booking.birthdate\" class=\"opacity-70\">al costo di</span> <strong ng-if=\"!booking.birthdate\" ng-bind-html=\"booking.treatmentPrice?booking.treatmentPrice:booking.treatment.start_price | labelRadioButtonFilter: \'euro\'\"></strong><br class=\"hidden-xs\"><strong>{{ booking.date4Labels.format() | date:\'EEEE d MMMM\' }}</strong> <span class=\"opacity-70\">dalle</span> <strong>{{booking.availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">alle</span> <strong>{{booking.availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">da:</span></h3><div class=\"user-wrap centered\"><div class=\"user-name title\">{{booking.availability.user.data.firstname}}</div><div class=\"user-description row\"><div class=\"col-xs-offset-1 col-xs-10 col-md-offset-3 col-md-6\">{{booking.availability.user.data.description}}</div></div></div></div></div></div><div ng-if=\"!(booking.landing && !booking.user && booking.customerId)\" class=\"step_number\"><strong>{{ booking.dateTimeStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section></div><div class=\"switch-item2\" ng-if=\"booking.store.booking_online || booking.customer\"></div></div><section class=\"row box box-customer-data\" ng-if=\"booking.isUser && booking.tenantDataLoaded && (!booking.env.tenant==\'Italia\' || booking.user) && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Note Appuntamento</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"input-group-addon\"><i class=\"icon-event_note\"></i></div><textarea id=\"note\" name=\"note\" class=\"form-control\" placeholder=\"Note\" rows=\"3\" ng-model=\"booking.note\"></textarea></div></div></div></section><section class=\"row box box-customer-data\" ng-show=\"booking.isUser && (booking.availability || booking.isOver) && (!booking.env.tenant==\'Italia\' || booking.user) && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Riepilogo prenotazione di {{booking.customer.firstname}} (telefono: {{booking.customer.phone}})</h3></div><div class=\"col-md-12 box-body\"><h3 class=\"title resume-sentence\"><span class=\"opacity-70\">Il trattamento</span> <strong>{{booking.treatment.name }}</strong> <span class=\"opacity-70\">sar&agrave; eseguito</span><span ng-show=\"booking.priceOverride>0\">al costo di</span> <strong ng-show=\"booking.priceOverride>0\" ng-bind-html=\"booking.treatmentPrice?booking.treatmentPrice:booking.priceOverride | labelRadioButtonFilter: \'euro\'\"></strong> <strong ng-show=\"booking.priceOverride==0\">Omaggio</strong><br class=\"hidden-xs\"><span class=\"opacity-70\">il giorno</span> <strong ng-show=\"!booking.isOver\">{{ booking.availability.date_start | dateTimeStringToLabel }}</strong> <strong ng-show=\"booking.isOver\">{{ booking.date | dateTimeStringToLabel }}</strong> <span class=\"opacity-70\">dalle</span> <strong ng-show=\"!booking.isOver\">{{booking.availability.date_start | splitTimeFilter | limitTo:5}}</strong> <strong ng-show=\"booking.isOver\">{{booking.overDateStart | date: \'HH:mm\'}}</strong> <span ng-show=\"!booking.isOver\" class=\"opacity-70\">alle</span> <strong ng-show=\"!booking.isOver\">{{booking.availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span ng-show=\"booking.isOver\" class=\"opacity-70\">(in overbooking)</span><br class=\"hidden-xs\"><span class=\"opacity-70\">da</span> <strong ng-show=\"!booking.isOver\">{{booking.availability.user.data.firstname}}</strong> <strong ng-show=\"booking.isOver\">{{booking.operator.role.user.firstname}}</strong> <span class=\"opacity-70\">nel centro di</span> <strong>{{booking.store.alias}}</strong></h3></div></section><div class=\"cta-wrap centered\" ng-if=\"booking.store.booking_online && !booking.existLeadComm\"><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.sendData()\" ng-if=\"booking.env.anonymous_access || booking.user\" ng-disabled=\"(!booking.gender && !booking.landing.treatment_id) || booking.existLeadComm || booking.isSaving || costumerForm.$invalid || (!booking.isOver && !booking.availability || booking.isOver && (!booking.customer || !booking.operator.id || !booking.date || !booking.overDateStart))\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"booking.appointmentId==null\">Prenota ora</span> <span ng-if=\"booking.appointmentId!=null\">Sposta</span></button><br><a class=\"or-call centered\" ng-if=\"!booking.isUser\" href=\"tel:{{booking.store.phone}}\"><div class=\"call-icon\"><i class=\"icon-phone\"></i></div><div class=\"call-info\"><span class=\"small-txt\">oppure contattaci telefonicamente</span><div class=\"call-number\">{{ booking.store.phone }}</div></div><div class=\"clearfix\"></div></a></div><div class=\"footer full-width\" ng-if=\"!booking.isUser\">&copy; {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br><a href=\"{{booking.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div><footer class=\"main-header full-width\"><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div></footer></form></div>");
$templateCache.put("app/booking/completed.html","<div class=\"container page-booking page-completed\"><header class=\"main-header full-width\"><div class=\"logo\"></div><div class=\"banner\" ng-if=\"!completed.env.hideBanner && !completed.env.apis\"></div></header><section><i class=\"icon-done\"></i><h1 class=\"title title-main\">Grazie {{ completed.appointment.customer.firstname }} per l\'appuntamento!</h1><div><h4><strong>Verrai contattato</strong> al numero di telefono che hai indicato da una nostra operatrice<br>per confermare i dati dell\'appuntamento.</h4></div><div ng-if=\"false\"><p>Più Condividi e più ti ricarichi!<br>Per ogni amico che porti a {{completed.env.company}}, una sorpresa ti aspetta!</p><p><button class=\"sharer button btn btn-social\" data-sharer=\"twitter\" data-title=\"{{completed.env.company}} - Epilazione, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Laser, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Twitter</button> <button class=\"sharer button btn btn-social\" data-sharer=\"facebook\" data-title=\"{{completed.env.company}} - Epilazione, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Laser, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Facebook</button> <button class=\"sharer button btn btn-social\" data-sharer=\"googleplus\" data-title=\"{{completed.env.company}} - Epilazione, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Laser, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Google+</button> <button class=\"sharer button btn btn-social\" data-sharer=\"telegram\" data-title=\"{{completed.env.company}} - Epilazione, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Laser, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"http://booking.{{completed.env.domain}}\">Telegram</button> <button class=\"sharer button btn btn-social\" data-sharer=\"whatsapp\" data-title=\"{{completed.env.company}} - Epilazione, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Laser, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"http://booking.{{completed.env.domain}}\">Whatsapp</button></p></div></section><div class=\"footer full-width\">© {{completed.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{completed.env.info_email}}\">{{completed.env.info_email}}</a><br><a ng-if=\"completed.env.info_number\" href=\"tel:{{completed.env.info_number}}\">{{completed.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/notauthorized.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 class=\"title title-main\">Si è verificato un errore.</h1><div><h4>I dati inseriti non sono validi.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/promoalready.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 class=\"title title-main\">Hai già prenotato il tuo trattamento omaggio!</h1><div><h4>Grazie! Ci vediamo nel nostro centro.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/promoexpired.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 class=\"title title-main\">Purtroppo la promozione non è più valida!</h1><div><h4></h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/main/messages.html","<p class=\"has-error\" ng-message=\"required\">Questo campo è obbligatorio</p><p class=\"has-error\" ng-message=\"minlength\">Questo campo è troppo corto</p><p class=\"has-error\" ng-message=\"maxlength\">Questo campo è troppo lungo</p><p class=\"has-error\" ng-message=\"email\">Questa email non è valida</p><p class=\"has-error\" ng-message=\"pattern\">Questa email non è valida</p>");
$templateCache.put("app/phonefriends/completed.html","<div class=\"container page-booking page-completed\"><header class=\"main-header full-width\"><div class=\"logo\"></div><div class=\"banner\"></div></header><section><i class=\"icon-done\"></i><h1 class=\"title title-main\">Grazie per le segnalazioni!</h1><div><h4><div ng-if=\"customer.last_store_id != null\">Mostra questo messaggio nel negozio {{ customer.lastStore.data.name}}<br>per ricevere immeditamente un trattamento <strong>gratuito</strong> a tua scelta.</div><div ng-if=\"customer.last_store_id == null\">Mostra questo messaggio nel centro {{phonefriend.env.company}} pi&ugrave; vicino<br>per ricevere immeditamente un trattamento <strong>gratuito</strong> a tua scelta.</div></h4></div></section><div class=\"footer full-width\">© {{phonefriends.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{phonefriends.env.info_email}}\">{{phonefriends.env.info_email}}</a><br><a ng-if=\"phonefriends.env.info_number\" href=\"tel:{{phonefriends.env.info_number}}\">{{phonefriends.env.info_number}}</a><br><a href=\"{{phonefriends.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div></div>");
$templateCache.put("app/phonefriends/phonefriends.html","<div class=\"container page-booking\"><header class=\"main-header full-width\"><div ng-if=\"phonefriends.env.tenant != \'Bios\'\" class=\"logo\"></div><div ng-if=\"phonefriends.env.tenant == \'Bios\'\" class=\"logo-bios\"></div><div ng-if=\"!phonefriends.isUser\" class=\"banner\"></div></header><section ng-if=\"!phonefriends.isUser\"><h1 class=\"title title-main\">Invita 5 amici per ricevere subito<br>un trattamento <strong>GRATIS</strong></h1></section><section ng-if=\"phonefriends.user\"><h4 style=\"text-align: center;\">v{{phonefriends.version}} | <span ng-if=\"phonefriends.user.type==\'operator\' || phonefriends.user.type==\'storemngr\'\" class=\"operator-circle\" style=\"background-color: {{ phonefriends.user.color }};\"></span> <span>{{phonefriends.user.firstname}} {{phonefriends.user.lastname}}</span> <span ng-if=\"phonefriends.user.type!=\'operator\' && phonefriends.user.type!=\'storemngr\'\">[{{phonefriends.user.type}}]</span> <span ng-if=\"phonefriends.user.type==\'operator\' || phonefriends.user.type==\'storemngr\'\">[{{phonefriends.user.store.alias}} <span ng-if=\"phonefriends.user.type==\'storemngr\'\">*</span>]</span></h4><h1 class=\"title title-main\">Inserimento PhoneFriends</h1></section><section class=\"row box box-customer-data\"><div class=\"col-md-12 box-header title-container\"><h3 ng-if=\"!phonefriends.isUser\" class=\"title\">Il tuo numero di <span>cellulare</span></h3><h3 ng-if=\"phonefriends.user\" class=\"title\"><span>Cellulare</span> del cliente segnalante</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><form name=\"custumerForm\" role=\"form\" id=\"custumerForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': customerForm.phone.$invalid && customerForm.phone.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone\" name=\"phone\" class=\"form-control\" placeholder=\"Il tuo cellulare\" ng-model=\"phonefriends.customer.phone\" ng-disabled=\"phonefriends.customerChecking || phonefriends.customerLoaded==true\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" required=\"\"></div><div ng-show=\"phonefriends.customerChecking\"><i class=\"icon-cached\"></i> ricerca in corso ...</div><div class=\"non-cliente\" ng-show=\"phonefriends.customerLoaded==false\"><strong>Non sei ancora cliente {{phonefriends.env.company}}? Rivolgiti al centro {{phonefriends.env.company}} pi&ugrave; vicino.</strong></div><div class=\"help-block\" ng-messages=\"customerForm.phone.$error\" ng-show=\"customerForm.phone.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div><span class=\"small-txt\">il cellulare è necessario per invitare i tuoi amici</span></div><div ng-hide=\"phonefriends.customerLoaded\" class=\"cta-wrap centered\"><button id=\"btn-pf-start\" ng-class=\"{ issaving: phonefriends.customerChecking }\" class=\"btn btn-success btn-mega\" ng-click=\"phonefriends.checkCustomer()\" ng-disabled=\"phonefriends.customerChecking || customerForm.phone.$invalid\"><img src=\"assets/images/loading.svg\"> <span>Inizia</span></button></div></div></div></form></div></div></section><section class=\"row box box-customer-data\" ng-show=\"phonefriends.customerLoaded\"><div class=\"col-md-12 box-header title-container\"><h3 ng-if=\"!phonefriends.isUser\" class=\"title\">Invita 5 <span>amici</span></h3><h3 ng-if=\"phonefriends.user\" class=\"title\"><span>Amici</span> segnalati</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><wizard on-finish=\"finished()\" indicators-position=\"top\" name=\"addProspects\"><wz-step wz-title=\"Amica 1\"><form name=\"friend1Form\" role=\"form\" id=\"friend1Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend1Form.firstname1.$touched && friend1Form.firstname1.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend1Form.firstname1.$error\" ng-show=\"friend1Form.firstname1.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend1Form.phone1.$invalid && friend1Form.phone1.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend1Form.phone1.$error\" ng-show=\"friend1Form.phone1.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step1\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend1Form.phone1.$invalid || friend1Form.firstname1.$invalid\" ng-click=\"saveProspect(1)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button> <button id=\"btn-pf-step1p\" wz-next=\"\" class=\"btn btn-success btn-mega\" style=\"margin-top: 10px;\" ng-disabled=\"saving || friend1Form.phone1.$invalid || friend1Form.firstname1.$invalid\" ng-click=\"saveProspect(1,true)\"><img src=\"assets/images/loading.svg\"> Prenota</button></div></form></wz-step><wz-step wz-title=\"Amica 2\"><form name=\"friend2Form\" role=\"form\" id=\"friend2Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend2Form.firstname2.$touched && friend2Form.firstname2.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend2Form.firstname2.$error\" ng-show=\"friend2Form.firstname2.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend2Form.phone2.$invalid && friend2Form.phone2.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend2Form.phone2.$error\" ng-show=\"friend2Form.phone2.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step2\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend2Form.phone2.$invalid || friend2Form.firstname2.$invalid\" ng-click=\"saveProspect(2)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div><div class=\"cta-wrap centered\"></div></form></wz-step><wz-step wz-title=\"Amica 3\"><form name=\"friend3Form\" role=\"form\" id=\"friend3Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend3Form.firstname3.$touched && friend3Form.firstname3.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend3Form.firstname3.$error\" ng-show=\"friend3Form.firstname3.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend3Form.phone3.$invalid && friend3Form.phone3.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend3Form.phone3.$error\" ng-show=\"friend3Form.phone3.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step3\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend3Form.phone3.$invalid || friend3Form.firstname3.$invalid\" ng-click=\"saveProspect(3)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div></form></wz-step><wz-step wz-title=\"Amica 4\"><form name=\"friend4Form\" role=\"form\" id=\"friend4Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend4Form.firstname4.$touched && friend4Form.firstname4.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend4Form.firstname4.$error\" ng-show=\"friend4Form.firstname4.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend4Form.phone4.$invalid && friend4Form.phone4.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend4Form.phone4.$error\" ng-show=\"friend4Form.phone4.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step4\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend4Form.phone4.$invalid || friend4Form.firstname4.$invalid\" ng-click=\"saveProspect(4)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div></form></wz-step><wz-step wz-title=\"Amica 5\"><form name=\"friend5Form\" role=\"form\" id=\"friend5Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend5Form.firstname5.$touched && friend5Form.firstname5.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend5Form.firstname5.$error\" ng-show=\"friend5Form.firstname5.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend5Form.phone5.$invalid && friend5Form.phone5.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend5Form.phone5.$error\" ng-show=\"friend5Form.phone5.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step5\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend5Form.phone5.$invalid || friend5Form.firstname5.$invalid\" ng-click=\"saveProspect(5)\"><img src=\"assets/images/loading.svg\"> <span>Fine</span></button></div></form></wz-step></wizard><button id=\"btn-pf-step2_fine\" class=\"btn btn-success btn-mega\" ng-if=\"phonefriends.user && phonefriends.step!=4\" ng-click=\"phonefriends.back()\"><img src=\"assets/images/loading.svg\"> <span>Esci</span></button></div></div></div></div></section><div class=\"footer full-width\">© {{phonefriends.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{phonefriends.env.info_email}}\">{{phonefriends.env.info_email}}</a><br><a ng-if=\"phonefriends.env.info_number\" href=\"tel:{{phonefriends.env.info_number}}\">{{phonefriends.env.info_number}}</a><br><a href=\"{{phonefriends.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div><footer class=\"main-header full-width\"><div ng-if=\"phonefriends.env.tenant != \'Bios\'\" class=\"logo\"></div><div ng-if=\"phonefriends.env.tenant == \'Bios\'\" class=\"logo-bios\"></div></footer></div>");
$templateCache.put("app/components/radio-buttons/radio-buttons.html","<div class=\"radio-buttons-wrap\" ng-class=\"{disabled: option.disabled == true }\" ng-repeat=\"option in options\"><div value=\"{{option.value}}\" ng-click=\"$parent.select($parent.scope, option.value)\" ng-class=\"{active: option.active == true }\" class=\"radio-buttons {{ option.icon }}\"><span class=\"radio-buttons-txt\" ng-if=\"option.label\" ng-bind-html=\"option.label | labelRadioButtonFilter:option.type\"></span></div><div class=\"radio-buttons-desc\" ng-if=\"option.description\">{{ option.description }}</div><div class=\"radio-buttons-times opacity-70\" ng-if=\"option.start\">{{ option.start| limitTo:5 }} - {{ option.end | limitTo:5 }}</div></div>");}]);